// Translation files for Bulgarian and English

export const translations = {
  en: {
    // Common
    common: {
      save: "Save Changes",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      all: "All",
      done: "Done",
      loading: "Loading...",
      error: "Error",
      success: "Success",
      warning: "Warning",
      confirm: "Confirm",
      back: "Back",
      close: "Close",
      search: "Search",
      refresh: "Refresh",
      retry: "Retry",
      yes: "Yes",
      no: "No",
      unknown: "Unknown",
      total: "total",
      previous: "Previous",
      next: "Next",
      pageOf: "Page {page} of {total}",
      actions: "Actions",
      areYouSure: "Are you sure you want to",
    },
    // Navigation
    nav: {
      pos: "POS",
      dashboard: "Dashboard",
      inventory: "Inventory",
      suppliers: "Suppliers",
      deliveries: "Deliveries",
      analytics: "Analytics",
      auditLog: "Audit Log",
      napExports: "NAP Exports",
      menu: "Menu",
      staff: "Staff",
      settings: "Settings",
      startDay: "Start Day",
      myReport: "My Report",
      zReport: "Z Report",
      tableTimer: "Table Timer",
      reservations: "Reservations",
      expenses: "Expenses",
      discounts: "Discounts",
      reports: "Reports",
      reportsSection: "Reports",
      management: "Management",
    },
    // Login
    login: {
      title: "Quantbar",
      enterVenuePin: "Enter venue PIN",
      enterStaffPin: "Enter your staff PIN",
      venuePinPlaceholder: "Enter 6-digit venue PIN",
      staffPinPlaceholder: "Enter your 4-digit staff PIN",
      continue: "Continue",
      login: "Login",
      invalidPin: "Invalid PIN. Please try again.",
      accessDenied: "Access denied. Please contact your manager.",
      serverError: "Server Error: Cannot connect to server. Please check if the server is running.",
      serverErrorPrefix: "Server Error:",
      loginFailed: "Login failed. Please try again.",
      sessionExpired: "Session expired. Please log in again.",
      venuePinNumbersOnly: "Venue PIN must contain only numbers",
      staffPinNumbersOnly: "Staff PIN must contain only numbers",
      multipleFailuresWarning: "Warning: {count} failed attempts. Please verify your PINs.",
      enterEmail: "Enter your email to get started",
      emailPlaceholder: "your@email.com",
      noAccountFound: "No account found for this email",
      whichVenue: "Which venue do you want to use?",
      changeEmail: "Change email",
      lockDevice: "Lock this device to {venue}?",
      lockDeviceDescription: "Staff won't be able to switch venues on this device.",
      lockYes: "Lock to this venue",
      lockNo: "Keep unlocked",
      emailNotRecognized: "Email not recognized",
      staffEmailMismatch: "This device is signed in with a staff email that does not match this PIN",
      // Back-office login
      backOfficeDashboard: "Back-office dashboard",
      email: "Email",
      password: "Password",
      emailBackofficePlaceholder: "you@restaurant.com",
      signingIn: "Signing in…",
      signIn: "Sign In",
      needAccess: "Need access?",
      contactSupport: "Contact support",
      invalidEmailOrPassword: "Invalid email or password",
    },
    // Table Layout
    tableLayout: {
      manageTables: "Manage Tables",
      addTable: "Add New Table",
      existingTables: "Existing Tables",
      noTables: "No tables yet. Add your first table above!",
      tableNamePlaceholder: "e.g., T07, B03, VIP-1",
      deleteTable: "Delete Table",
      deleteTableConfirm: "Are you sure you want to delete {name}? This action cannot be undone.",
      deleteTableWarning: "Warning: This will permanently delete the table from your venue.",
      free: "Free",
      cleaning: "Cleaning",
      seated: "Seated",
      check: "Check",
      reserved: "Reserved",
      ordering: "Ordering",
      served: "Served",
      payment: "Payment",
      guest: "guest",
      guests: "guests",
      tableCleaned: "✓ Table Cleaned",
      loadingTables: "Loading tables...",
      refreshing: "Refreshing…",
      noTablesFound: 'No tables found matching "{query}"',
      startNewDay: "Start New Day",
      startNewDayConfirm: "This will reset all tables to FREE status. This action cannot be undone.",
      startNewDayWarning: "Warning: All table statuses will be reset to FREE. Active orders will remain saved but tables will be marked as available.",
      resetAllTables: "Reset All Tables",
      numberOfGuests: "Number of Guests",
      howManyGuests: "How many guests?",
      orEnterCustom: "Or enter custom number",
      maximumGuests: "Maximum: 20 guests",
      startOrder: "Start Order",
      openTable: "Open Table",
      mergeTables: "Merge Tables",
      mergeTablesTitle: "Merge Tables",
      selectTablesToMerge: "Select tables to merge with {tableName}",
      combinedCapacity: "Combined capacity: {capacity}",
      noFreeTablesToMerge: "No free tables available to merge",
      confirmMerge: "Merge & Open",
      mergedWith: "Merged with {tables}",
      keepMergedQuestion: "Keep tables merged?",
      keepMergedDescription: "Would you like to keep these tables merged for the next order, or split them back?",
      keepMerged: "Keep Merged",
      splitTables: "Split Tables",
      tableMergedRedirect: "This table is merged with {primaryTable}. Opening that order.",
      moveGuests: "Move Guests",
      moveGuestsInstruction: "Tap the table to move FROM",
      moveGuestsDestInstruction: "Now tap the destination table",
      moveGuestsConfirmTitle: "Move Guests",
      moveGuestsConfirmMessage: "Move all orders from {source} to {destination}?",
      moveGuestsSuccess: "Guests moved from {source} to {destination}",
      moveGuestsSelectOccupied: "Select an occupied table with guests",
      mergeTablesInstruction: "Tap the PRIMARY table for the merge",
      mergeTablesSecondaryInstruction: "Tap tables to add to merge, then confirm",
      mergeTablesConfirmTitle: "Merge Tables",
      mergeTablesConfirmMessage: "Merge {tables}? All orders will move to {primary}.",
      mergeTablesConfirmButton: "Merge",
      mergeTablesSuccess: "Tables merged successfully",
      cancelSelection: "Cancel",
      confirmSelection: "Confirm",
      editLayout: "Edit Layout",
      saveLayout: "Save Layout",
      savingLayout: "Saving...",
      cancelLayout: "Cancel",
      layoutEditBanner: "Layout edit mode — drag tables to reposition them, then click",
      seat: "seat",
      seats: "seats",
      pleaseEnterTableName: "Please enter a table name",
      pleaseEnterValidGuests: "Please enter a valid number of guests (1-20)",
      tableAlreadySeated: "Table already seated",
      openOrderToEdit: "Open the order to edit guests or items.",
      actionNotAllowed: "Action not allowed",
      finishOrVoidBeforeCleaning: "Table {tableName} is {state}. Finish or void the check before cleaning.",
      openOrder: "Open order",
      confirmTableCleaned: "Confirm that table {tableName} has been cleaned?",
      unableToDetermineVenue: "Unable to determine venue. Please log in again.",
      unknown: "Unknown",
      timerType: "Timer Type",
      noTimer: "No Timer",
      timerUpdated: "Timer setting updated",
      floor: "Zone",
      noFloor: "No Zone",
      addFloor: "Add Zone",
      newFloorName: "Zone name:",
      renameFloor: "Rename zone:",
      mainFloor: "Main",
      deleteZoneConfirm: "Delete \"{name}\"? Tables will move back to Main.",
    },
    // Order Screen
    orderScreen: {
      back: "← Back",
      discounts: "Discounts",
      guests: "Guests:",
      assignToGuest: "Assign to Guest",
      current: "Current:",
      guestNumber: "Guest {number}",
      food: "Food",
      drinks: "Drinks",
      extras: "Extras",
      all: "All",
      appetizers: "Appetizers",
      main: "Main",
      dessert: "Dessert",
      sides: "Sides",
      cocktails: "Cocktails",
      softDrinks: "Soft Drinks",
      beers: "Beers",
      whiskey: "Whiskey",
      liquors: "Liquors",
      wine: "Wine",
      customCocktails: "Custom Cocktails",
      other: "Other",
      loadingMenu: "Loading menu from the server...",
      retryNow: "Retry now",
      loadingMenuItems: "Loading menu...",
      noProducts: "No products available",
      noProductsDesc: "Please check back later or contact support",
      noItemsInCategory: "No items in this category",
      searchProducts: "Search items...",
      noSearchResults: 'No results for "{query}"',
      clearSearch: "Clear search",
      favourites: "Favourites",
      itemAdded: "{name} added to order",
      lastOrderRepeated: "Last order repeated",
      noPreviousOrder: "No previous order to repeat",
      tableCleared: "Table cleared",
      orderReset: "Order reset",
      resetOrder: "Reset Order",
      resetOrderConfirm: "This will clear all items from the order. Please provide a reason.",
      resetReasonPlaceholder: "Enter reason (e.g., Customer cancelled, Wrong order, etc.)",
      itemRemoved: "{name} removed from order",
      itemRemovedWithReason: "{name} removed (Reason: {reason})",
      failedToRemove: "Failed to remove item. Please try again.",
      addItemsFirst: "Add items to order first",
      selectItemsToFire: "Please select items to fire",
      menuLoading: "Menu is still loading. Please wait a moment and try again.",
      cannotFireInvalid: "Cannot fire invalid item(s): {names}",
      alreadyInProgress: "Selected items are already in progress or ready",
      itemsFired: " {count} item(s) fired! Items routed by category",
      printFailed: "Print failed — check printer connection",
      fireOrder: "Fire Order",
      requestPayment: "Request Payment",
      pleaseFireFirst: "Please fire the order first",
      unfiredItemsWarning: "{count} item(s) haven't been fired yet. Please fire all items before requesting payment.",
      itemStatusUpdated: "Item status updated to {status}",
      failedToUpdateStatus: "Failed to update item status",
      item: "item",
      items: "items",
      pleaseEnterReason: "Please enter a reason",
      noValidItemsToFire: "No valid items to fire",
      cannotFireInProgress: "Cannot fire items that are already in progress or ready",
      table: "Table",
      order: "Order",
      guest: "guest",
      guests: "guests",
      noItemsInOrder: "No items in order",
      clearTable: "Clear Table",
      repeatLastOrder: "Repeat Last Order",
      removeItem: "Remove item",
      changeDiscount: "Change discount",
      applyDiscount: "Apply discount",
      selectAll: "Select All",
      deselectAll: "Deselect All ({count} selected)",
      sendingOrder: "Sending Order...",
      fire: "Fire",
      fireOrder: "Fire Order",
      itemsFiredShort: "✓ Items fired",
      subtotal: "Subtotal",
      tax: "Tax (10%)",
      total: "Total",
      qty: "Qty",
      each: "each",
      statusPending: "PENDING",
      statusInProgress: "IN PROGRESS",
      statusReady: "READY",
      statusCancelled: "CANCELLED",
      customizeOrder: "Customize your order",
      noCustomizationOptions: "No customization options available",
      optionalAddOns: "Optional Add-ons",
      requiredSelectOption: "Required - Select an option",
      totalPrice: "Total Price:",
      next: "Next →",
      addToOrder: "Add to Order",
    },
    // Remove Item Modal
    removeItemModal: {
      removeItem: "Remove Item",
      removeFromOrder: "Remove",
      fromOrder: "from order",
      reason: "Reason",
      selectReason: "Select a reason",
      reasonWrongItem: "Wrong item",
      reasonCustomerCancelled: "Customer cancelled",
      reasonAlreadyOrdered: "Already ordered",
      reasonUnavailable: "Item unavailable",
      reasonOther: "Other",
      specifyReason: "Please specify the reason",
      pleaseEnterReason: "Please enter a reason for removing this item",
      managerApprovalRequired: "Manager approval is required to remove this item",
      managerApprovalRequiredTitle: "Manager Approval Required",
      managerApprovalConfirm: "I confirm that a manager has approved this item removal",
      managerRequiredBlocked: "A manager must remove this item",
      managerRequiredBlockedDesc: "Voiding ordered items has been restricted to managers in venue settings.",
    },
    // Payment Screen
    paymentScreen: {
      payment: "Payment",
      subtotal: "Subtotal",
      tax: "Tax (10%)",
      tip: "Tip",
      total: "Total",
      selectPaymentMethod: "Select Payment Method",
      cash: "Cash",
      card: "Card",
      mixed: "Mixed",
      amountGiven: "Amount Given",
      change: "Change",
      selectTip: "Select Tip",
      customTip: "Custom Tip",
      noTip: "No Tip",
      processPayment: "Process Payment",
      noOrderToPayFor: "No order found — please fire items before proceeding to payment",
      selectPaymentMethodFirst: "Please select a payment method",
      cashShort: "Cash received ({currency} {amount}) is less than total (€{total}).",
      invalidSplitCount: "Invalid split count",
      invalidSplitAmount: "Invalid split amount",
      processing: "Processing...",
      paymentProcessed: "Payment processed successfully",
      showReceipt: "Show Receipt",
      receipt: "Receipt",
      printReceipt: "Print Receipt",
      close: "Close",
      noItemsInOrder: "No items in order",
      returnToTables: "Return to Tables",
      backToOrder: "← Back to Order",
      billSummary: "Bill Summary",
      splitPayment: "Split Payment",
      splitPaymentDesc: "Enable to split the bill between multiple people",
      enableSplit: "Enable Split",
      disable: "Disable",
      evenSplit: "Even Split",
      byGuest: "By Guest",
      numberOfPeople: "Number of people:",
      peopleCount: "{count} People",
      peopleSummary: "{count} people",
      guestsSummary: "{count} guests",
      amountPerPersonDisplay: "€{amount} each",
      cashCurrency: "Cash currency",
      changeEquivalentBGN: "Change equivalent in BGN",
      cashLessThanTotal: "Cash (converted to EUR) is less than the bill total — please adjust the amount.",
      orderItems: "Order Items",
      guest: "Guest",
      paymentProcessedSuccess: "Payment processed and table cleared successfully",
      paymentProcessedButNoTableUpdate: "Payment processed but could not update table status",
      paymentFailed: "Payment failed. Please try again.",
      printingFiscalReceipt: "Printing fiscal receipt...",
      fiscalReceiptPrinted: "Fiscal receipt #{receiptNo} printed",
      fiscalPrintFailed: "Fiscal receipt failed: {error}",
      retryFiscal: "Retry",
      skipFiscal: "Skip (Manager only)",
      skipFiscalPaymentDone: "Continue — payment recorded",
      printPreBill: "Print Pre-Bill",
      // Article split
      splitByItem: "By Item",
      assignItems: "Assign Items to Guests",
      unassignedItems: "{count} unassigned item(s)",
      assigned: "assigned",
      noItemsAssigned: "No items assigned yet",
      guestBill: "Guest {number}",
      payGuest: "Pay Guest {number}",
      guestPaid: "Guest {number} paid!",
      guestPaidLabel: "Guest {number} - Paid",
      allGuestsPaid: "All guests paid!",
      assignAllTo: "All → Guest {number}",
      tipShare: "Tip share",
      proceedToPayment: "Proceed to Payment",
      guestProgress: "Guest {current} of {total}",
      cannotCancelMidSplit: "Complete all guest payments to close the bill",
      backToAssignment: "← Back to item assignment",
    },
    // Settings
    settings: {
      venueSettings: "Venue Settings",
      venueSettingsDesc: "Update operational preferences for the floor, staff, and reporting.",
      settingsSaved: "Settings saved {time}",
      floorOperations: "Floor Operations",
      floorOperationsDesc: "Control how the floor updates and handles automatic transitions.",
      autoCloseChecks: "Auto-close checks after payment",
      autoCloseChecksDesc: "Automatically mark tables as FREE once payment is captured.",
      requirePin: "Require staff PIN on order edits",
      requirePinDesc: "Prompt for the assigned staff PIN before modifying an open check.",
      staffPermissions: "Staff Permissions",
      staffPermissionsDesc: "Control which actions non-manager staff can perform.",
      voidRequiresManager: "Voiding requires manager",
      voidRequiresManagerDesc: "When on, only managers, owners, and admins can void or storno orders. Waiters will be blocked.",
      floorRefreshCadence: "Floor refresh cadence",
      floorRefreshCadenceMinutes: "(minutes)",
      notificationsTheme: "Notifications & Theme",
      notificationsThemeDesc: "Stay informed about inventory, staffing, and analytics signals.",
      inventoryAlerts: "Inventory alerts",
      inventoryAlertsDesc: "Notify managers when stock drops below par levels.",
      staffingReminders: "Staffing reminders",
      staffingRemindersDesc: "Send reminders for upcoming shifts or when breaks exceed limits.",
      analyticsDigests: "Analytics digests",
      analyticsDigestsDesc: "Deliver daily performance summaries via email.",
      darkMode: "Dark mode interface",
      darkModeDesc: "Keep Quantbar in the low-light friendly theme.",
      restaurantLogout: "Restaurant Logout",
      restaurantLogoutDesc: "Exit the restaurant venue and return to login screen. You will need to enter the venue PIN again to access this venue.",
      loggingOut: "Logging out...",
      restaurantLogoutButton: "Restaurant Logout",
      logoutConfirm: "Are you sure you want to log out of the restaurant? You will need to enter the venue PIN again to access this venue.",
      language: "Language",
      languageDesc: "Change the interface language",
      languageEnglish: "English",
      languageBulgarian: "Bulgarian",
      english: "English",
      bulgarian: "Български",
      fiscalPrinter: "Fiscal Printer",
      fiscalPrinterDesc: "Datecs FP-700/FP-800 for fiscal receipts.",
      fiscalPrinterPort: "COM Port",
      fiscalOperatorPassword: "Operator Password",
      testConnection: "Test Connection",
      connected: "Connected",
      disconnected: "Disconnected",
      kitchenPrinter: "Kitchen Printer",
      kitchenPrinterDesc: "ESC/POS printer for kitchen tickets.",
      kitchenPrinterIp: "Printer IP Address",
      myVenues: "My Venues",
      myVenuesDesc: "View data from your other venues. Your device stays on {venue}.",
      myVenuesHome: "home",
      myVenuesViewing: "viewing",
      myVenuesBackTo: "Back to {venue}",
      viewingBanner: "Viewing {venue}",
      viewingBannerDesc: "Data shown is from this venue. Your device is still on {home}.",
    },
    // Print Configuration
    printConfig: {
      title: "Print Stations",
      description: "Configure thermal printers and route orders to kitchen, bar, or other stations.",
      autoPrint: "Auto-print on fire",
      autoPrintDesc: "Automatically print tickets when items are fired.",
      printers: "Printers",
      addPrinter: "Add Printer",
      noPrinters: "No printers configured yet.",
      printerName: "Name",
      ipAddress: "IP Address",
      port: "Port",
      testing: "Testing...",
      testOk: "Printer connected",
      testFailed: "Connection failed",
      saveFailed: "Failed to save print config",
      addPrinterFirst: "Add a printer first",
      stations: "Stations",
      addStation: "Add Station",
      noStations: "No stations configured yet.",
      stationName: "Station Name",
      linkedPrinter: "Printer",
      copies: "Copies",
      routing: "Order Routing",
      routingDesc: "Choose which menu categories print to which station.",
      category: "Category",
      legacySettings: "Legacy printer settings (single IP)",
      dietaryFlagsSection: "Dietary / Allergen Flags",
      dietaryFlagsSectionDesc: "Define quick-tap flags for dietary needs or allergens. These appear on order items and print on tickets.",
      noDietaryFlags: "No custom flags yet — using built-in defaults.",
      addFlag: "Add",
      flagLabelPlaceholder: "e.g. Halal, Kosher, Gluten-Free...",
    },
    // Item Notes & Dietary Flags
    itemNotes: {
      title: "Item Notes & Flags",
      dietaryFlags: "Dietary / Allergens",
      freeNotes: "Special Instructions",
      placeholder: "e.g. well done, no sauce, extra spicy...",
      glutenFree: "Gluten-Free",
      dairyFree: "Dairy-Free",
      nutFree: "Nut-Free",
      vegan: "Vegan",
      vegetarian: "Vegetarian",
      spicy: "Extra Spicy",
      noSpice: "No Spice",
      allergy: "Allergy Alert",
    },
    // Inventory
    inventory: {
      inventory: "Inventory",
      addItem: "Add Item",
      editItem: "Edit Item",
      itemName: "Item Name",
      category: "Category",
      unit: "Unit",
      quantity: "Quantity",
      parLevel: "Par Level",
      minimumQuantity: "Minimum Quantity",
      useBottles: "Use Bottles",
      directQuantity: "Direct Quantity",
      bottleSize: "Bottle Size (ml)",
      numberOfBottles: "Number of Bottles",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      deleteItem: "Delete Item",
      deleteItemConfirm: "Are you sure you want to delete {name}?",
      critical: "Critical",
      warning: "Warning",
      healthy: "Healthy",
      noItems: "No inventory items found",
      loading: "Loading inventory...",
      failedToLoad: "Failed to load inventory",
      itemSaved: "Item saved successfully",
      itemDeleted: "Item deleted successfully",
      failedToSave: "Failed to save item",
      failedToDelete: "Failed to delete item",
      pleaseEnterItemName: "Please enter an item name",
      pleaseAddBottleEntry: "Please add at least one bottle entry",
      pleaseEnterQuantity: "Please enter quantity",
      pleaseEnterBottles: "Please enter number of bottles",
      selectCategory: "Select category",
      selectSize: "Select size",
      custom: "Custom",
      customMl: "Custom (ml)",
      count: "Count",
      remove: "Remove",
      totalQuantity: "Total Quantity",
      enterQuantity: "Enter quantity",
      negativeHint: "Use negative numbers to subtract (e.g. -3 for items used before logging delivery)",
      parLevelBottles: "Par Level (bottles)",
      parLevel: "Par Level (target quantity)",
      parLevelBottlesPlaceholder: "e.g., 5 bottles",
      optional: "Optional",
      minimumQuantityBottles: "Minimum Quantity (bottles)",
      minimumQuantity: "Minimum Quantity (alert threshold)",
      minimumQuantityBottlesPlaceholder: "e.g., 2 bottles",
      addQuantity: "Add Quantity",
      item: "Item",
      quantityAddedSuccess: "Quantity added successfully",
      deleteItemConfirm: "Delete {name}? This cannot be undone.",
      totalItems: "Total Items",
      criticalAlerts: "Critical Alerts",
      belowMinimum: "Below minimum",
      allGood: "All good",
      warnings: "Warnings",
      belowParLevel: "Below par level",
      atOrAbovePar: "At or above par",
      accessDenied: "Access Denied",
      accessDeniedDesc: "You don't have permission to view inventory.",
      inventoryManagement: "Inventory Management",
      inventoryManagementDesc: "Track and manage your inventory items",
      activeAlerts: "Active Alerts",
      acknowledge: "Acknowledge",
      loadingInventory: "Loading inventory...",
      noInventoryMatches: "No inventory matches \"{query}\".",
      noInventoryItems: "No inventory items yet",
      addFirstItem: "Add Your First Item",
      quantityInputMethod: "Quantity Input Method",
      byBottles: "By Bottles (for liquids)",
      bottleEntries: "Bottle Entries (can add multiple sizes)",
      addEntry: "+ Add Entry",
      items: "items",
      uncategorized: "Uncategorized",
      onHand: "On hand",
      par: "Par",
      min: "Min",
      quickAdd: "+ Add",
      numberOfBottles: "Number of bottles",
      errorLoading: "Error loading inventory:",
      error404Message: "The inventory API endpoint may not be available. Please ensure the server is running and the migration has been applied.",
      errorConnectionMessage: "Please check your connection and try refreshing the page.",
      unitMl: "ml (milliliters)",
      unitG: "g (grams)",
      unitKg: "kg (kilograms)",
      unitLiters: "L (liters)",
      unitPieces: "pieces",
      unitEach: "each",
      categorySpirits: "Spirits",
      categoryMixers: "Mixers",
      categorySyrups: "Syrups",
      categoryFood: "Food",
      categoryProduce: "Produce",
      categoryProteins: "Proteins",
      categoryDairy: "Dairy",
      categoryOther: "Other",
      itemNamePlaceholder: "e.g., Absolut Vodka, Campari",
      alertAcknowledged: "Alert acknowledged",
      failedToAcknowledge: "Failed to acknowledge alert",
      threshold: "threshold",
      linked: "Linked",
      unableToLoad: "Unable to load inventory",
      current: "Current",
      itemSingular: "item",
      itemPlural: "items",
      bottle: "bottle",
      restock: "Restock",
      failedToRestock: "Failed to restock inventory",
      enterPositiveQuantity: "Enter a restock quantity greater than 0.",
      currentStock: "Current stock",
      quantityToAdd: "Quantity to add",
      notes: "Notes",
      optionalRestockNote: "Optional restock note",
      restocking: "Restocking...",
      deduct: "Deduct",
      quantityToDeduct: "Quantity to deduct",
      optionalDeductNote: "Optional deduction note",
      deducting: "Deducting...",
      failedToDeduct: "Failed to deduct inventory",
      cannotDeductMoreThanStock: "Cannot deduct more than current stock.",
      readOnlyMobileNonManagers: "Read-only on mobile for non-managers.",
      liveSchemaDescription: "Uses the live inventory schema from the server and migrations.",
      categoryPlaceholder: "spirits, mixers, food...",
      // Multi-location
      locations: "Locations",
      addLocation: "Add Location",
      editLocation: "Edit Location",
      deleteLocation: "Delete Location",
      defaultLocation: "Default",
      setAsDefault: "Set as Default",
      transferStock: "Transfer Stock",
      transferFrom: "From",
      transferTo: "To",
      transferQuantity: "Quantity to transfer",
      transferred: "Stock transferred",
      trackByLocation: "Track by Location",
      trackByLocationDesc: "Split inventory quantities across multiple storage locations",
      combinedMode: "Combined",
      splitMode: "Split by Location",
      noLocations: "No locations configured",
      addFirstLocation: "Add your first location to get started",
      locationBreakdown: "Location Breakdown",
      modeChangeWarning: "Changing inventory mode will reorganize your stock data",
      createLocationFirst: "Create at least one location before enabling split mode",
      locationNamePlaceholder: "e.g. Front Bar, Warehouse, Kitchen",
      allLocations: "All Locations",
      selectLocation: "Select location",
      locationDeleted: "Location deleted",
      locationCreated: "Location created",
      locationUpdated: "Location updated",
      cannotDeleteWithStock: "Transfer all stock from this location before deleting",
      // Locations
      manageLocations: "Locations",
      locationsDesc: "Organize stock into active (front) and reserve (storage) locations",
      locationNamePlaceholder: "e.g., Front Bar, Warehouse",
      locTypeActive: "Active",
      locTypeReserve: "Reserve",
      noLocations: "No locations yet",
      defaultLocation: "Default",
      setDefault: "Set Default",
      // Cost & Waste
      costPrice: "Cost",
      waste: "Waste",
      recordWaste: "Record Waste",
      wasteRecorded: "Waste recorded successfully",
      wasteQuantityPlaceholder: "Quantity wasted",
      selectWasteReason: "Select reason...",
      wasteExpired: "Expired",
      wasteSpoiled: "Spoiled",
      wasteDamaged: "Damaged",
      wasteSpilled: "Spilled",
      wasteQuality: "Quality issue",
      wasteOther: "Other",
      each: "each",
      searchPlaceholder: "Search inventory...",
    },
    menu: {
      pinToFavourites: "Pin to favourites",
      removeFromFavourites: "Remove from favourites",
      itemCode: "Item Code / SKU",
      itemCodePlaceholder: "e.g. ESP001",
      autoGenerate: "Auto-generate",
      codeDuplicate: "This code is already in use",
    },
    // Menu Management
    menuManagement: {
      menuManagement: "Menu Management",
      addMenuItem: "Add Menu Item",
      editMenuItem: "Edit Menu Item",
      itemName: "Item Name",
      category: "Category",
      subcategory: "Subcategory",
      price: "Price",
      description: "Description",
      ingredients: "Ingredients",
      addIngredient: "Add Ingredient",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      deleteItem: "Delete Menu Item",
      deleteItemConfirm: "Are you sure you want to delete {name}?",
      noItems: "No menu items found",
      loading: "Loading menu items...",
      failedToLoad: "Failed to load menu items",
      itemSaved: "Menu item saved successfully",
      itemDeleted: "Menu item deleted successfully",
      failedToSave: "Failed to save menu item",
      failedToDelete: "Failed to delete menu item",
      missingVenueInfo: "Missing venue information. Please log in again.",
      goToLogin: "Go to Login",
      manageMenuItemsAndIngredients: "Manage menu items and ingredients",
      all: "All",
      searchMenuItems: "Search menu items",
      managerAccessRequiredMobile: "Manager access is required on mobile.",
      itemsLabel: "Items",
      customizable: "Customizable",
      addFirstMenuItem: "Add Your First Menu Item",
      dragToReorder: "Drag items to reorder. Click \"Save Order\" to apply changes.",
      saveOrder: "Save Order",
      orderLabel: "Order",
      moveUp: "Up",
      moveDown: "Down",
      noDescription: "No description",
      itemDeletedToast: "{name} deleted",
      itemUpdatedToast: "{name} updated",
      itemAddedToast: "{name} added to menu",
      menuOrderSaved: "Menu order saved successfully",
      failedToSaveOrder: "Failed to save menu order",
      categoryFood: "Food",
      categoryDrinks: "Drinks",
      categoryExtras: "Extras",
      subcategoryAppetizers: "Appetizers",
      subcategoryMain: "Main",
      subcategoryDessert: "Dessert",
      subcategorySides: "Sides",
      subcategoryOther: "Other",
      subcategoryCocktails: "Cocktails",
      subcategorySoftDrinks: "Soft Drinks",
      subcategoryBeers: "Beers",
      subcategoryWhiskey: "Whiskey",
      subcategoryLiquors: "Liquors",
      subcategoryWine: "Wine",
      subcategoryCustomCocktails: "Custom Cocktails",
      unit: "Unit",
      itemNamePlaceholder: "Menu item name",
      unitPlaceholder: "each, serving, ml, g, etc.",
      descriptionPlaceholder: "Item description...",
      selectInventoryItem: "Select inventory item",
      qtyPerOrder: "Qty/order",
      qtyPerOrderTooltip: "Quantity used per order (e.g., 50 ml per shot)",
      loadingInventoryItems: "Loading inventory items...",
      noInventoryItemsAvailable: "No inventory items available for {category}. Add items in the Inventory page first.",
      thisCategory: "this category",
      noIngredientsAdded: "No ingredients added. Click \"Add Ingredient\" to link inventory items.",
      removeIngredient: "Remove ingredient",
      enableCustomizationOptions: "Enable Customization Options",
      customizationDescription: "Add modifier groups for customizable items.",
      useTemplate: "Use Template",
      customSetup: "Custom Setup",
      templateGinTonic: "Gin & Tonic",
      templateSpritz: "Spritz",
      templateMartini: "Martini",
      templateOldFashioned: "Old Fashioned",
      templateNegroni: "Negroni",
      selectTemplate: "Select a template...",
      applyTemplate: "Apply Template",
      modifierGroups: "Modifier Groups",
      addModifierGroup: "Add Modifier Group",
      modifierGroupN: "Modifier Group {n}",
      modifierLabelPlaceholder: "Modifier label (e.g., Select Gin)",
      required: "Required",
      orderTooltip: "Order (1 = first, 2 = second, etc.)",
      priceChange: "Price change",
      removeModifierGroup: "Remove modifier group",
      options: "Options",
      populateFromInventory: "Populate from Inventory",
      spirits: "Spirits",
      mixers: "Mixers",
      syrups: "Syrups",
      softDrinks: "Soft Drinks",
      addOption: "Add Option",
      aperol: "Aperol",
      gin: "Gin",
      vodka: "Vodka",
      dry: "Dry",
      sweet: "Sweet",
      olive: "Olive",
      lemonTwist: "Lemon Twist",
      angostura: "Angostura",
      orange: "Orange",
      sugarCube: "Sugar Cube",
      simpleSyrup: "Simple Syrup",
      standard: "Standard",
      selectGin: "Select Gin",
      selectTonic: "Select Tonic",
      selectWineProsecco: "Select Wine/Prosecco",
      selectAperitif: "Select Aperitif",
      sodaWater: "Soda Water",
      selectSpirit: "Select Spirit",
      selectVermouth: "Select Vermouth",
      garnish: "Garnish",
      selectWhiskey: "Select Whiskey",
      bitters: "Bitters",
      sweetener: "Sweetener",
      campari: "Campari",
      optionName: "Option name",
      removeOption: "Remove option",
      noOptions: "No options. Add at least one option.",
      updateItem: "Update Item",
      addItem: "Add Item",
      pleaseEnterItemName: "Please enter a menu item name",
      pleaseEnterValidPrice: "Please enter a valid price",
      newModifier: "New Modifier",
      option1: "Option 1",
      optionN: "Option {n}",
      none: "None",
      available: "available",
      unitEach: "each",
      manageCategories: "Manage Categories",
      autoGenerate: "Auto-generate",
      itemCode: "Item Code / SKU",
      itemCodePlaceholder: "e.g. ESP001",
    },
    // Menu Categories
    menuCategories: {
      title: "Manage Categories",
      addCategory: "New Category",
      add: "Add",
      addSubcategory: "Add Subcategory",
      categoryNamePlaceholder: "e.g. Desserts",
      subcategoryNamePlaceholder: "e.g. Cakes",
      categoryAdded: "Category added",
      categorySaved: "Category saved",
      categoryDeleted: "Category deleted",
      subcategoryAdded: "Subcategory added",
      subcategorySaved: "Subcategory saved",
      subcategoryDeleted: "Subcategory deleted",
      deleteCategoryConfirm: "Delete category \"{name}\"? This will also delete all its subcategories.",
      deleteSubcategoryConfirm: "Delete subcategory \"{name}\"?",
      failedToLoad: "Failed to load categories",
      failedToSave: "Failed to save",
      failedToDelete: "Failed to delete",
    },
    // Staff
    staff: {
      teamRosterDesc: "View who is on shift and manage the venue team from mobile.",
      failedToLoad: "Failed to load staff roster",
      searchStaff: "Search staff",
      showing: "Showing",
      totalRoster: "Total roster",
      manageStaff: "Manage staff",
      exitManageMode: "Exit manage mode",
      noStaffFoundDesc: "Try a different search or department filter.",
      hireNewStaffDesc: "Create a staff account and generate operator credentials.",
      jobTitlePlaceholder: "Server, bartender, line cook...",
      notClockedIn: "Not clocked in",
      saveCredentialsBeforeClosing: "Save these credentials before closing. They are shown once for",
      fireStaffModalDesc: "Remove {name} from the active venue staff roster. Their operator code stays in audit history.",
      editStaffDesc: "Update the staff member details and permissions.",
      hiring: "Hiring...",
      firing: "Firing...",
      teamRoster: "Team Roster",
      teamRosterDesc: "View who is on shift and manage the venue team from mobile.",
      teamMember: "team member",
      teamMembers: "team members",
      onDutyToday: "on duty today",
      hireStaff: "+ Hire Staff",
      onDuty: "On duty",
      off: "Off",
      failedToLoad: "Failed to load staff roster",
      searchStaff: "Search staff",
      showing: "Showing",
      totalRoster: "Total roster",
      manageStaff: "Manage staff",
      exitManageMode: "Exit manage mode",
      noStaffFound: "No staff members found.",
      noStaffFoundDesc: "Try a different search or department filter.",
      noStaffRegistered: "No staff members are registered for this venue.",
      hireNewStaff: "Hire New Staff Member",
      hireNewStaffDesc: "Create a staff account and generate operator credentials.",
      firstName: "First Name",
      lastName: "Last Name",
      jobTitle: "Job Title",
      jobTitlePlaceholder: "Server, bartender, line cook...",
      department: "Department",
      role: "Role",
      selectDepartment: "Select Department",
      staff: "Staff",
      manager: "Manager",
      notClockedIn: "Not clocked in",
      staffMemberHired: "Staff Member Hired!",
      staffMemberHiredDesc: "{name} has been added to the team.",
      saveCredentialsBeforeClosing: "Save these credentials before closing. They are shown once for",
      saveCredentials: "Save these credentials:",
      operatorCode: "Operator Code:",
      pin: "PIN:",
      pinWarning: "⚠️ This PIN will not be shown again. Please share it securely with the staff member.",
      gotIt: "Got it",
      fireStaff: "Fire Staff Member",
      fireStaffConfirm: "Are you sure you want to fire {name}?",
      fireStaffDesc: "This will remove their PIN and deactivate their account, but their operator code will be kept for audit logs.",
      fireStaffModalDesc: "Remove {name} from the active venue staff roster. Their operator code stays in audit history.",
      fireStaffMember: "Fire Staff Member",
      staffMemberFired: "Staff member fired successfully",
      staffMemberHiredSuccess: "Staff member hired successfully",
      failedToHire: "Failed to hire staff member",
      failedToFire: "Failed to fire staff member",
      accessDenied: "Access Denied",
      accessDeniedDesc: "You don't have permission to view staff management.",
      loadingRoster: "Loading staff roster...",
      service: "Service",
      bar: "Bar",
      kitchen: "Kitchen",
      frontDesk: "Front Desk",
      leadership: "Leadership",
      all: "All",
      firstNameLastNameRequired: "First name and last name are required",
      hire: "Hire",
      fire: "Fire",
      clockIn: "Clock-in",
      department: "Department",
      staffManagement: "Staff Management",
      editStaff: "Edit Staff",
      editStaffMember: "Edit Staff Member",
      editStaffDesc: "Update the staff member details and permissions.",
      updateStaff: "Update Staff",
      staffMemberUpdated: "Staff member updated successfully",
      failedToUpdate: "Failed to update staff member",
      changePosition: "Change Position",
      hiring: "Hiring...",
      firing: "Firing...",
      save: "Save",
      cancel: "Cancel",
    },
    // Dashboard
    dashboard: {
      loadingDashboard: "Loading dashboard…",
      venue: "Venue {id}",
      updated: "Updated {time}",
      refresh: "Refresh ↻",
      days: "days",
      salesOverview: "Sales Overview",
      noPriorData: "No prior data",
      vsYesterday: "{percent} vs yesterday",
      revenue: "Revenue",
      orders: "Orders",
      averageOrderValue: "Average Order Value",
      completedTickets: "Completed tickets",
      revenuePerOrders: "Revenue / Orders",
      hourlyRevenue: "Hourly Revenue",
      allVenues: "All venues",
      topProducts: "Top Products",
      total: "total",
      paymentMix: "Payment Mix",
      breakdownByTenderType: "Breakdown by tender type",
      noPaymentsRecorded: "No payments recorded for this period.",
      payments: "payments",
      tips: "tips",
      vsLastWeek: "{percent} vs last week",
      // Alerts & Trends
      alertsTrends: "Alerts & Trends",
      critical: "Critical",
      warning: "Warning",
      info: "Info",
      noAlertsInPeriod: "No alerts in this period.",
      metric: "Metric",
      forecast: "Forecast",
      noForecastAvailable: "No forecast available.",
      // Financial Summary
      financialSummary: "Financial Summary",
      cogs: "COGS",
      grossMargin: "Gross Margin",
      sold: "sold",
      cost: "cost",
      margin: "margin",
      noProductFinancials: "No product financials for this range.",
      tracked: "tracked",
      // Inventory Snapshot
      inventorySnapshot: "Inventory Snapshot",
      expectedQty: "Expected Qty",
      rollingTotalMovement: "Rolling total based on movement",
      countedQty: "Counted Qty",
      latestStockCounts: "Latest stock counts",
      variance: "Variance",
      units: "units",
      avg: "Avg",
      lowStock: "Low Stock",
      noLowStockAlerts: "No low stock alerts for this venue.",
      doc: "DoC",
      restock: "Restock",
      // Operational Timing
      operationalTiming: "Operational Timing",
      p50Prep: "P50 Prep",
      p90Prep: "P90 Prep",
      p50Total: "P50 Total",
      tableTurnP50: "Table Turn (P50)",
      min: "min",
      tableUtilization: "Table Utilization",
      tables: "tables",
      // Staff Leaderboard
      staffLeaderboard: "Staff Leaderboard",
      avgOrdersHr: "Avg Orders/Hr",
      avgTipsHr: "Avg Tips/Hr",
      voids: "Voids",
      noShiftsRecorded: "No shifts recorded for this period.",
      ordHr: "ord/hr",
      hr: "/hr",
    },
    // Quick Add Modal
    quickAddModal: {
      pleaseEnterQuantity: "Please enter quantity",
      addedBottles: "Added {count} bottles",
      manualAddition: "Manual addition",
    },
    // Analytics
    analytics: {
      analytics: "Analytics",
      subtitle: "Monitor sales, product velocity, inventory risk, and staffing performance.",
      accessDenied: "Access Denied",
      accessDeniedDesc: "You don't have permission to view analytics.",
      revenueTrends: "Revenue Trends",
      topSellingItems: "Top Selling Items",
      inventoryAlerts: "Inventory Alerts",
      staffPerformance: "Staff Performance",
      venue: "Venue {id}",
      pageOf: "Page {page} of {totalPages}",
      previous: "Previous",
      next: "Next",
      unableToLoadRevenue: "Unable to load revenue analytics.",
      totalRevenue: "Total Revenue",
      totalOrders: "Total Orders",
      averageOrderValue: "Average Order Value",
      prevPeriod: "Prev: {revenue} ({change})",
      prevPeriodOrders: "Prev: {orders} ({change})",
      revenuePerOrders: "Revenue / Orders",
      summary: "Summary",
      summaryDescription: "Headline metrics for the selected period.",
      revenueTrendsDescription: "{start} → {end} ({days} days, grouped by {groupBy})",
      selectVenueAndRange: "Select a venue and range to view revenue performance.",
      noRevenueData: "No revenue data found for the selected filters.",
      revenue: "Revenue",
      orders: "Orders",
      aov: "AOV",
      revenueBuckets: "Revenue Buckets",
      revenueBucketsDescription: "Aggregated revenue by time bucket.",
      bucketStart: "Bucket Start",
      bucketEnd: "Bucket End",
      unableToLoadTopItems: "Unable to load top items.",
      sortBy: "Sort by",
      quantity: "Quantity",
      grossProfit: "Gross Profit",
      marginPercent: "Margin %",
      averagePrice: "Average Price",
      descending: "Descending",
      ascending: "Ascending",
      search: "Search",
      filterByProductName: "Filter by product name",
      clear: "Clear",
      dateRangeDays: "{start} → {end} ({days} days)",
      visualizeProductPerformance: "Visualize product performance by revenue and quantity.",
      noProductPerformanceData: "No product performance data for the selected filters.",
      totalQuantity: "Total Quantity",
      margin: "Margin",
      topItemsDetail: "Top Items Detail",
      topItemsDetailDescription: "Detailed revenue, quantity, and profitability metrics.",
      product: "Product",
      category: "Category",
      avgPrice: "Avg price",
      unableToLoadInventoryAlerts: "Unable to load inventory alerts.",
      daysOfCoverThreshold: "Days of cover threshold",
      variancePercentThreshold: "Variance % threshold",
      inventoryAlertsBySeverity: "Inventory Alerts by Severity",
      monitorCriticalInventoryRisks: "Monitor critical inventory risks.",
      noInventoryAlertsDetected: "No inventory alerts detected for the selected filters.",
      alerts: "Alerts",
      totalAlerts: "Total alerts",
      alertsFlaggedDuringPeriod: "Alerts flagged during the selected period",
      inventoryAlertDetail: "Inventory Alert Detail",
      inventoryAlertDetailDescription: "Root causes and severity classification for each flagged product.",
      severity: "Severity",
      severityCritical: "Critical",
      severityWarning: "Warning",
      severityInfo: "Info",
      qty: "Qty",
      reorderPoint: "Reorder pt.",
      daysCover: "Days cover",
      variance: "Variance",
      variancePercent: "Variance %",
      lastCount: "Last count",
      reasons: "Reasons",
      unableToLoadStaffAnalytics: "Unable to load staff analytics.",
      sortMetric: "Sort metric",
      compositeScore: "Composite score",
      ordersPerHour: "Orders / hour",
      tipsPerHour: "Tips / hour",
      voids: "Voids",
      tips: "Tips",
      hours: "Hours",
      range: "Range",
      dateRange: "{start} → {end}",
      selectVenue: "Select a venue",
      staffLeaderboard: "Staff leaderboard",
      staffLeaderboardDescription: "Overall performance score that rewards high orders/hour and tips/hour, and penalizes a high void count.",
      noStaffPerformanceRecorded: "No staff performance recorded for the selected filters.",
      avgOrdersPerHour: "Avg orders/hour",
      avgTipsPerHour: "Avg tips/hour",
      staffDetail: "Staff detail",
      staffDetailDescription: "Deep dive into orders, tips, hours worked, and composite score.",
      name: "Name",
      role: "Role",
      ordersPerHourShort: "Orders/hr",
      tipsPerHourShort: "Tips/hr",
      composite: "Composite",
      dateRange: "Date range",
      groupBy: "Group by",
      day: "Day",
      week: "Week",
      month: "Month",
      allCategories: "All categories",
      loading: "Loading…",
      noDataAvailable: "No data available for the selected filters.",
      noEntriesToDisplay: "No entries to display.",
      sections: "Sections",
      previousPeriod: "Previous Period",
    },
    // Z Report (daily venue Z report)
    zReport: {
      title: "Daily Z Report",
      subtitle: "End-of-day financial summary. Resets daily counters.",
      failedToLoad: "Failed to load Z report",
      print: "Print Z Report",
      receipts: "Receipts",
      revenueWithVat: "Revenue (with VAT)",
      revenueNoVat: "Revenue (excl. VAT)",
      vatTotal: "Total VAT",
      tips: "Tips",
      discounts: "Discounts",
      voids: "Voids",
      voidAmount: "Voided Amount",
      paymentBreakdown: "Payment Breakdown",
      vatBreakdown: "VAT Breakdown",
      vatRate: "VAT Rate",
      netAmount: "Net",
      vatAmount: "VAT",
      grossAmount: "Gross",
      period: "Period",
      noActivity: "No closed sales found for this date.",
      cash: "Cash",
      card: "Card",
      other: "Other",
    },
    // My Report (daily staff report)
    myReport: {
      title: "My Daily Report",
      subtitle: "Your daily earnings, orders, and tip calculator.",
      failedToLoad: "Failed to load daily report",
      shift: "Shift",
      ongoing: "ongoing",
      noShift: "No shift recorded for this day",
      revenue: "Revenue",
      tips: "Tips (recorded)",
      orders: "Orders",
      voids: "Voids",
      ordersPerHour: "Orders / hour",
      hoursWorked: "Hours worked",
      paymentBreakdown: "Payment Breakdown",
      tipsLabel: "tips",
      tipCalculator: "Tip Calculator",
      tipCalculatorDesc: "Enter the total cash you counted to calculate your tip. Cash revenue is subtracted to show your earnings.",
      cashRevenue: "Cash revenue (what you should have)",
      cashCounted: "Cash you counted",
      yourTips: "Your tips from cash",
      shortage: "Shortage",
      shortageDesc: "You need to add this amount to cover the revenue.",
      noActivity: "No activity recorded for this day.",
    },
    // Discounts
    discounts: {
      discountManagement: "Discount Management",
      createDiscount: "Create Discount",
      editDiscount: "Edit Discount",
      failedToLoad: "Failed to load discounts",
      pleaseEnterDiscountName: "Please enter a discount name",
      pleaseEnterValidDiscountValue: "Please enter a valid discount value",
      percentageCannotExceed100: "Percentage discount cannot exceed 100%",
      discountUpdatedSuccessfully: "Discount updated successfully",
      discountCreatedSuccessfully: "Discount created successfully",
      failedToUpdateDiscount: "Failed to update discount",
      failedToCreateDiscount: "Failed to create discount",
      discountActivated: "Discount activated",
      discountDeactivated: "Discount deactivated",
      loadingDiscounts: "Loading discounts...",
      noDiscountsCreatedYet: "No discounts created yet",
      createFirstDiscount: "Create your first discount to get started",
      deactivate: "Deactivate",
      activate: "Activate",
      inactive: "Inactive",
      discountName: "Discount Name",
      discountNamePlaceholder: "e.g., Happy Hour, Student Discount",
      discountType: "Discount Type",
      percentage: "Percentage (%)",
      fixedAmount: "Fixed Amount (€)",
      discountValue: "Discount Value",
      enterValueBetween0And100: "Enter a value between 0 and 100",
      active: "Active",
      update: "Update",
      create: "Create",
      applyDiscount: "Apply Discount",
      customAmount: "Custom Amount",
      enterDiscountAmount: "Enter discount amount",
      selectDiscountOrEnterAmount: "Please select a discount or enter an amount",
      noActiveDiscounts: "No active discounts available",
      loadingDiscounts: "Loading discounts...",
      discountApplied: "Discount applied",
      customTip: "Custom amount",
      pleaseEnterQuantity: "Please enter quantity",
      addedBottles: "Added {count} bottles",
      manualAddition: "Manual addition",
    },
    // Apply Discount Modal
    applyDiscountModal: {
      applyDiscount: "Apply Discount",
      customAmount: "Custom Amount",
      enterDiscountAmount: "Enter discount amount",
      selectDiscountOrEnterAmount: "Please select a discount or enter an amount",
      noActiveDiscounts: "No active discounts available",
      loadingDiscounts: "Loading discounts...",
      item: "Item",
      subtotal: "Subtotal",
      discount: "Discount",
      total: "Total",
      cancel: "Cancel",
    },
    // Audit Logs
    auditLogs: {
      auditLog: "Audit Log",
      description: "View user actions (login, voids, storno, config changes) with filters.",
      accessDenied: "Access Denied",
      accessDeniedDesc: "You don't have permission to view audit logs.",
      failedToLoad: "Failed to load audit logs",
      from: "From",
      to: "To",
      action: "Action",
      all: "All",
      operatorCode: "Operator Code",
      operatorCodePlaceholder: "e.g. 0002",
      loading: "Loading...",
      showingEntries: "Showing {count} of {total} entries",
      refresh: "Refresh",
      time: "Time",
      operator: "Operator",
      details: "Details",
      noEventsFound: "No audit events found for the selected filters.",
      code: "Code",
      pageOf: "Page {page} of {totalPages}",
      previous: "Previous",
      next: "Next",
      actionLogin: "Login",
      actionLogout: "Logout",
      actionSaleOpen: "Sale Open",
      actionItemAdd: "Item Add",
      actionItemVoid: "Item Void",
      actionSaleVoid: "Sale Void",
      actionSaleStorno: "Sale Storno",
      actionPayment: "Payment",
      actionConfigChange: "Config Change",
      actionSessionCreated: "Session Created",
      actionSessionRefreshed: "Session Refreshed",
      actionSessionLocked: "Session Locked",
      actionSessionUnlocked: "Session Unlocked",
      actionTableMove: "Table moved",
      actionTableMergeOccupied: "Tables merged (occupied)",
      actionStaffClockIn: "Clock in",
      actionStaffClockOut: "Clock out",
      actionStaffShiftAdjust: "Shift adjusted",
      detailsSaleOpen: "Table: {table}, Guests: {guests}",
      detailsItemVoid: "Voided item {itemId}",
      detailsSaleStorno: "Reason: {reason}",
      detailsPayment: "Method: {method}, Total: {total}",
      detailsConfigChange: "{entity} {action} {name}",
      detailsSession: "Session: {sessionId}",
    },
    // NAP Exports
    napExports: {
      napExports: "NAP Exports (Н-18 т.18)",
      description: "Download summary sales, payments, and detailed line items in CSV format for NAP inspections.",
      accessDenied: "Access Denied",
      accessDeniedDesc: "You don't have permission to view NAP exports.",
      failedToDownload: "Failed to download export",
      from: "From",
      to: "To",
      operatorCodeOptional: "Operator Code (optional)",
      operatorCodePlaceholder: "e.g. 0002",
      summarySales: "18.1 Summary Sales",
      summarySalesDesc: "One row per sale with amounts and timestamps.",
      payments: "18.2 Payments",
      paymentsDesc: "Payments per sale with method, amounts, and FU number.",
      lineItems: "18.3 Line Items",
      lineItemsDesc: "Detailed items per sale (articles, quantities, VAT).",
      stornoSales: "18.4 Storno Sales",
      stornoSalesDesc: "Stornoed sales by line (with storno date, time, and FU number).",
      annulledItems: "18.5 Annulled Items",
      annulledItemsDesc: "Voided items per sale with annul date, time, and operator.",
      deliveriesBasic: "18.6 Deliveries (basic)",
      deliveriesBasicDesc: "Basic delivery records from inventory (quantities; other fields blank for now).",
      deliveryLines: "18.7 Delivery Lines",
      deliveryLinesDesc: "Detailed delivery entries per inventory item (quantities only).",
      stockMovement: "18.8 Stock Movement",
      stockMovementDesc: "Opening, debit, credit, and closing quantities per inventory item.",
      products: "18.9 Products",
      productsDesc: "Product codes, names, categories, and lifetime timestamps.",
      venuesWorkstations: "18.9 Venues & Workstations",
      venuesWorkstationsDesc: "Exports venues and POS devices (workstations) for the current venue.",
      usersRoles: "18.9 Users & Roles",
      usersRolesDesc: "Operators with their codes; use separate Roles and Payment Methods exports for full nomenclatures.",
      roles: "18.9 Roles",
      rolesDesc: "Role codes, Bulgarian names, and permissions JSON for operators.",
      paymentMethods: "18.9 Payment Methods",
      paymentMethodsDesc: "Static list of payment method codes (cash, card, other).",
      preparingExport: "Preparing export file, please wait...",
    },
    // Clock In
    clockIn: {
      quantbar: "Quantbar",
      clockIn: "Clock In",
      pleaseClockInToStartShift: "Please clock in to start your shift",
      clockingIn: "Clocking in...",
      failedToClockIn: "Failed to clock in",
      skipForNow: "Skip for now",
    },
    // Top Bar
    topBar: {
      searchTables: "Search tables",
      account: "Account",
      clockOutAndLogOut: "Clock Out & Log Out",
      logOut: "Log Out",
    },
    // Table Timer Add-on
    reservations: {
      title: "Reservations",
      newReservation: "New Reservation",
      editReservation: "Edit Reservation",
      today: "Today",
      upcoming: "Upcoming",
      noReservations: "No reservations for this day",
      noUpcoming: "No upcoming reservations",
      createFirst: "Create one",
      guestName: "Guest Name",
      guestNamePlaceholder: "John Smith",
      guestNameRequired: "Guest name is required",
      phone: "Phone",
      date: "Date",
      time: "Time",
      duration: "Duration",
      partySize: "Party Size",
      isParty: "Party / Event",
      selectTables: "Tables",
      noTables: "No tables found",
      notes: "Notes",
      notesPlaceholder: "Special requests, allergies...",
      save: "Save",
      create: "Create Reservation",
      close: "Close",
      updateStatus: "Update reservation status",
      seatGuests: "Seat Guests",
      markCompleted: "Mark Completed",
      noShow: "No Show",
      cancel: "Cancel Reservation",
      guests: "guests",
      reserve: "Reserve",
    },
    expenses: {
      title: "Business Expenses",
      addExpense: "Add Expense",
      editExpense: "Edit Expense",
      description: "Description",
      category: "Category",
      netAmount: "Net Amount",
      vatAmount: "VAT (20%)",
      totalAmount: "Total",
      date: "Date",
      recurrence: "Recurrence",
      oneTime: "One-time",
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      yearly: "Yearly",
      notes: "Notes",
      noExpenses: "No expenses recorded yet",
      suggestionsHint: "These are suggestions — click to add what applies to your venue",
      loading: "Loading expenses...",
      failedToLoad: "Failed to load expenses",
      created: "Expense created",
      updated: "Expense updated",
      deleted: "Expense deleted",
      totalExpenses: "Total Expenses",
      recurring: "Recurring",
      confirmDelete: "Delete this expense?",
      ghostRent: "Rent",
      ghostUtilities: "Utilities",
      ghostSupplies: "Supplies",
      ghostInsurance: "Insurance",
      ghostMaintenance: "Maintenance & Repairs",
      ghostSalaries: "Salaries & Wages",
      ghostMarketing: "Marketing & Advertising",
      ghostLicenses: "Licenses & Permits",
    },
    tableTimer: {
      title: "Table Timer",
      startTimer: "Start Timer",
      stopTimer: "Stop Timer",
      running: "Running",
      elapsed: "Elapsed",
      runningCost: "Running Cost",
      selectPricingTier: "Please select a pricing tier",
      timerStarted: "Timer started",
      timerCancelled: "Timer cancelled",
      sessionEnded: "Session ended",
      totalCharge: "Total charge",
      addedToOrder: "Timer charge added to order",
      noPricingTiers: "No pricing tiers configured. Set them up in Settings.",
      liveSessions: "Live Sessions",
      settings: "Settings",
      noActiveSessions: "No active timer sessions right now.",
      // Pricing Tier Editor
      pricingTiers: "Pricing Tiers",
      pricingTiersDesc: "Configure pricing for timed activities (billiard, pool, tennis, etc.)",
      existingTiers: "Existing Tiers",
      createTier: "Create Pricing Tier",
      editTier: "Edit Pricing Tier",
      tierName: "Activity Name",
      tierNamePlaceholder: "e.g. Billiard, Tennis, Pool",
      tierNameRequired: "Activity name is required",
      pricingBreakpoints: "Pricing Breakpoints",
      addRow: "Add Breakpoint",
      preview: "Preview",
      atLeastOneTier: "At least one pricing breakpoint is required",
      minutesMustBePositive: "Minutes must be positive",
      priceMustBePositive: "Price cannot be negative",
      duplicateMinutes: "Duplicate minute values are not allowed",
      tierCreated: "Pricing tier created",
      tierUpdated: "Pricing tier updated",
      tierDeleted: "Pricing tier deleted",
      // Table Timer Page
      pageTitle: "Table Timer",
      pageDesc: "Manage pricing tiers and assign timers to tables",
      tableAssignments: "Table Assignments",
      tableAssignmentsDesc: "Choose which tables have a timer and which pricing tier they use",
      noTables: "No tables found. Create tables in the POS first.",
      timerAssigned: "Timer assigned to {tableName}",
      timerRemoved: "Timer removed from {tableName}",
      addonNotEnabled: "Table Timer Add-on Not Enabled",
      addonNotEnabledDesc: "Enable the Table Timer add-on from your subscription to use this feature.",
    },
    // Suppliers
    suppliers: {
      title: "Suppliers",
      addSupplier: "Add Supplier",
      editSupplier: "Edit Supplier",
      name: "Name",
      contactName: "Contact Name",
      phone: "Phone",
      email: "Email",
      notes: "Notes",
      actions: "Actions",
      edit: "Edit",
      deactivate: "Deactivate",
      reactivate: "Reactivate",
      searchPlaceholder: "Search suppliers...",
      showInactive: "Show inactive",
      inactive: "Inactive",
      noSuppliersYet: "No suppliers yet",
      noSuppliersHint: "Add your first supplier to start logging deliveries.",
      noSuppliersMatch: "No suppliers match your search",
      supplierCreated: "Supplier created",
      supplierUpdated: "Supplier updated",
      supplierDeactivated: "Supplier deactivated",
      supplierReactivated: "Supplier reactivated",
      nameRequired: "Supplier name is required",
      failedToLoad: "Failed to load suppliers",
      failedToSave: "Failed to save supplier",
      failedToDeactivate: "Failed to deactivate supplier",
      failedToReactivate: "Failed to reactivate supplier",
      create: "Create",
      update: "Update",
      cancel: "Cancel",
      contactPerson: "Contact person",
      namePlaceholder: "e.g. Metro Cash & Carry",
      deliveryScheduleHint: "Delivery schedule, payment terms, etc.",
    },
    // Deliveries
    deliveries: {
      title: "Deliveries",
      newDelivery: "New Delivery",
      logDelivery: "Log Delivery",
      back: "Back",
      invoiceDetails: "Invoice Details",
      supplier: "Supplier",
      selectSupplier: "Select supplier...",
      invoiceNumber: "Invoice Number",
      invoiceDate: "Invoice Date",
      deliveryDate: "Delivery Date",
      notes: "Notes",
      optionalNotes: "Optional delivery notes",
      lineItems: "Line Items",
      addLine: "Add Line",
      item: "Item",
      selectItem: "Type to search or create...",
      quantity: "Quantity",
      costPerUnit: "Cost/Unit",
      expiry: "Expiry",
      total: "Total",
      remove: "Remove",
      grandTotal: "Grand Total",
      cancel: "Cancel",
      saving: "Saving...",
      deliveryCreated: "Delivery logged successfully",
      failedToCreate: "Failed to create delivery",
      failedToLoad: "Failed to load deliveries",
      failedToLoadData: "Failed to load data",
      selectSupplierError: "Please select a supplier",
      addLineError: "Add at least one valid line item",
      // List page
      allSuppliers: "All Suppliers",
      allStatuses: "All Statuses",
      from: "From",
      to: "To",
      status: "Status",
      date: "Date",
      noDeliveries: "No deliveries found",
      noDeliveriesHint: "Log your first delivery to track costs and stock.",
      loading: "Loading deliveries...",
      // Statuses
      statusPending: "Pending",
      statusVerified: "Verified",
      statusPartiallyVerified: "Partially Verified",
      statusDisputed: "Disputed",
      // Detail page
      deliveryDetail: "Delivery Detail",
      expected: "Expected",
      received: "Received",
      verified: "Verified",
      unverified: "Unverified",
      verifyAll: "Verify All",
      deleteDelivery: "Delete Delivery",
      deleteDeliveryConfirm: "Are you sure you want to delete this delivery? This will reverse all stock changes.",
      verificationProgress: "Verification Progress",
      verifyLine: "Verify Line",
      quantityReceived: "Quantity Received",
      verifyNotes: "Notes (optional)",
      verify: "Verify",
      deliveryVerified: "Delivery verified",
      deliveryDeleted: "Delivery deleted",
      lineVerified: "Line verified",
      failedToVerify: "Failed to verify",
      failedToDelete: "Failed to delete delivery",
      // Detail extras
      loadingDelivery: "Loading delivery...",
      deliveryNotFound: "Delivery not found",
      deliveryDetails: "Delivery Details",
      verifiedBanner: "All items verified. This delivery is complete.",
      invoice: "Invoice",
      totalCost: "Total Cost",
      verifiedProgress: "Verified: {verified} / {total} lines",
      lineTotal: "Line Total",
      action: "Action",
      pendingStatus: "Pending",
      verifiedStatus: "Verified",
      verifyModalDesc: "Enter the quantity actually received. If it differs from the expected amount, the stock lot will be adjusted.",
      verifyNotesPlaceholder: "e.g. 2 bottles damaged",
      enterValidQty: "Enter a valid received quantity",
      allLinesVerified: "All lines verified",
      deleteDeliveryTitle: "Delete Delivery",
      deleteDeliveryMsg: "Delete this delivery? This will reverse all stock lot entries.",
      // Form extras
      newInventoryItem: "New Inventory Item",
      nameRequired: "Name *",
      unitRequired: "Unit *",
      creating: "Creating...",
      create: "Create",
      failedToCreateItem: "Failed to create item",
      failedToLoadSuppliers: "Failed to load suppliers",
      failedToLoadInventory: "Failed to load inventory",
      createNewItem: "Create \"{name}\" as new inventory item",
      // Bottle mode
      bottles: "Bottles",
      bottlesPlaceholder: "Qty",
      bottleSizeMl: "Bottle Size (ml)",
      bottleSizePlaceholder: "e.g. 700",
      costPerBottle: "Cost/Bottle",
      perMl: "ml",
      bottleModeHint: "Items tracked in ml will automatically switch to bottle entry.",
    },
    // Stock Lots
    stockLots: {
      title: "Stock Lots",
      weightedAvgCost: "Weighted Avg Cost",
      totalStockValue: "Total Stock Value",
      activeLots: "Active Lots",
      lastDeliveryCost: "Last Delivery Cost",
      consumptionMethod: "Consumption method",
      lot: "Lot",
      exhausted: "Exhausted",
      perUnit: "/unit",
      received: "Received",
      expires: "Expires",
      expired: "EXPIRED",
      noLots: "No stock lots yet.",
      noLotsHint: "Log a delivery to create the first lot.",
      loading: "Loading lots...",
      viewLots: "Lots",
    },
    // Inventory Settings (added to settings page)
    inventorySettings: {
      title: "Inventory Settings",
      description: "Configure how stock is consumed and costs are calculated.",
      consumptionMethod: "Consumption Method",
      consumptionMethodDesc: "Determines the order in which stock lots are consumed when items are sold.",
      fifo: "FIFO (First In, First Out)",
      fefo: "FEFO (First Expiry, First Out)",
      manual: "Manual",
      costCalculation: "Cost Calculation",
      costCalculationDesc: "How product unit cost is determined for margin calculations.",
      weightedAverage: "Weighted Average",
      lastDelivery: "Last Delivery Cost",
      lotSpecific: "Lot-Specific",
      saved: "Inventory settings saved",
      failedToSave: "Failed to save inventory settings",
      failedToLoad: "Failed to load inventory settings",
    },
    // New Inventory Item (inline creation)
    newInventoryItem: {
      title: "New Inventory Item",
      name: "Name",
      unit: "Unit",
      category: "Category",
      categoryPlaceholder: "e.g. Spirits",
      cancel: "Cancel",
      create: "Create",
      creating: "Creating...",
      failedToCreate: "Failed to create item",
    },
    // Margin
    margin: {
      margin: "Margin",
      marginPercent: "Margin %",
      costPrice: "Cost Price",
      sellPrice: "Sell Price",
      noMarginData: "No margin data available",
    },
    // Account / Portal
    account: {
      account: "Account",
      accountDesc: "Your organization overview and plan status.",
      organization: "Organization",
      ownerEmail: "Owner email",
      currentPlan: "Current plan",
      billingCycle: "Billing cycle",
      periodEnds: "Period ends",
      venues: "Venues",
      manageSubscription: "Manage subscription →",
      browseAddons: "Browse add-ons →",
      viewVenues: "View venues →",
      ownerOnly: "Account details are only visible to the organization owner.",
      // Subscription
      subscription: "Subscription",
      subscriptionDesc: "Manage your plan and billing.",
      plan: "Plan",
      maxVenues: "Max venues",
      cancelSubscription: "Cancel subscription",
      cancelNotice: "Your plan stays active until the end of the billing period. You can reactivate at any time.",
      keepSubscription: "Keep subscription",
      confirmCancellation: "Confirm cancellation",
      availablePlans: "Available Plans",
      current: "Current",
      switchTo: "Switch to {plan}",
      perMonth: "/mo",
      // Add-ons
      addons: "Add-ons",
      addonsDesc: "Extend your POS with powerful extras.",
      active: "Active",
      marketplace: "Marketplace",
      noAddonsAvailable: "No add-ons available for your plan.",
      activate: "Activate",
      deactivate: "Deactivate",
      // Venues
      venuesTitle: "Venues",
      venuesDesc: "Your registered locations.",
      venueOwnerOnly: "Venue management is only available to the organization owner.",
      added: "Added",
      activeStatus: "Active",
      inactiveStatus: "Inactive",
      noVenuesFound: "No venues found. Venues are managed from the POS application.",
      venuesFromPos: "Venues are created and configured from the POS application (desktop/tablet).",
    },
    // Auth Launch
    launch: {
      missingToken: "Missing launch token.",
      failedAuth: "Failed to authenticate. Please sign in manually.",
      signInManually: "Sign in manually →",
      openingDashboard: "Opening dashboard…",
    },
    // Homepage
    home: {
      welcome: "Welcome, {name}!",
      role: "Role",
      logout: "Logout",
    },
  },
  bg: {
    // Common
    common: {
      save: "Запази промените",
      cancel: "Отказ",
      delete: "Изтрий",
      edit: "Редактирай",
      add: "Добави",
      all: "Всички",
      done: "Готово",
      loading: "Зареждане...",
      error: "Грешка",
      success: "Успех",
      warning: "Предупреждение",
      confirm: "Потвърди",
      back: "Назад",
      close: "Затвори",
      search: "Търсене",
      refresh: "Обнови",
      retry: "Опитай отново",
      yes: "Да",
      no: "Не",
      unknown: "Неизвестно",
      total: "общо",
      previous: "Предишна",
      next: "Следваща",
      pageOf: "Страница {page} от {total}",
      actions: "Действия",
      areYouSure: "Сигурни ли сте, че искате да",
    },
    // Navigation
    nav: {
      pos: "ПОС",
      dashboard: "Табло",
      inventory: "Склад",
      suppliers: "Доставчици",
      deliveries: "Доставки",
      analytics: "Статистика",
      auditLog: "Одит дневник",
      napExports: "НАП експорти",
      menu: "Меню",
      staff: "Персонал",
      settings: "Настройки",
      startDay: "Започни ден",
      myReport: "Моят отчет",
      zReport: "Дневен Отчет",
      tableTimer: "Таймер за маси",
      reservations: "Резервации",
      expenses: "Разходи",
      discounts: "Отстъпки",
      reports: "Отчети",
      reportsSection: "Отчети",
      management: "Управление",
    },
    // Login
    login: {
      title: "Quantbar",
      enterVenuePin: "Въведете PIN на заведението",
      enterStaffPin: "Въведете вашия персонален PIN",
      venuePinPlaceholder: "Въведете 6-цифрен PIN на заведението",
      staffPinPlaceholder: "Въведете вашия 4-цифрен персонален PIN",
      continue: "Продължи",
      login: "Вход",
      invalidPin: "Невалиден PIN. Моля, опитайте отново.",
      accessDenied: "Достъпът е отказан. Моля, свържете се с вашия мениджър.",
      serverError: "Грешка на сървъра: Не може да се свърже със сървъра. Моля, проверете дали сървърът работи.",
      serverErrorPrefix: "Грешка на сървъра:",
      loginFailed: "Входът не бе успешен. Моля, опитайте отново.",
      sessionExpired: "Сесията изтече. Моля, влезте отново.",
      venuePinNumbersOnly: "PIN на заведението трябва да съдържа само цифри",
      staffPinNumbersOnly: "Персоналният PIN трябва да съдържа само цифри",
      multipleFailuresWarning: "Предупреждение: {count} неуспешни опита. Моля, проверете вашите PIN кодове.",
      enterEmail: "Въведете имейла си, за да започнете",
      emailPlaceholder: "вашият@имейл.com",
      noAccountFound: "Няма намерен акаунт за този имейл",
      whichVenue: "Кое заведение искате да използвате?",
      changeEmail: "Промяна на имейл",
      lockDevice: "Заключване на устройството за {venue}?",
      lockDeviceDescription: "Персоналът няма да може да превключва заведения на това устройство.",
      lockYes: "Заключи за това заведение",
      lockNo: "Остави отключено",
      emailNotRecognized: "Имейлът не е разпознат",
      staffEmailMismatch: "Това устройство е влязло с имейл на персонал, който не съвпада с този PIN",
      // Back-office login
      backOfficeDashboard: "Табло за управление",
      email: "Имейл",
      password: "Парола",
      emailBackofficePlaceholder: "вие@ресторант.com",
      signingIn: "Влизане…",
      signIn: "Вход",
      needAccess: "Нуждаете се от достъп?",
      contactSupport: "Свържете се с поддръжката",
      invalidEmailOrPassword: "Невалиден имейл или парола",
    },
    // Table Layout
    tableLayout: {
      manageTables: "Управление на маси",
      addTable: "Добави нова маса",
      existingTables: "Съществуващи маси",
      noTables: "Все още няма маси. Добавете първата си маса по-горе!",
      tableNamePlaceholder: "напр., Т07, Б03, VIP-1",
      deleteTable: "Изтрий маса",
      deleteTableConfirm: "Сигурни ли сте, че искате да изтриете {name}? Това действие не може да бъде отменено.",
      deleteTableWarning: "Предупреждение: Това ще изтрие масата завинаги от вашето заведение.",
      free: "Свободна",
      cleaning: "Почистване",
      seated: "Заета",
      check: "Сметка",
      reserved: "Резервирана",
      ordering: "Поръчване",
      served: "Обслужена",
      payment: "Плащане",
      guest: "гост",
      guests: "гости",
      tableCleaned: "✓ Масата е почистена",
      loadingTables: "Зареждане на маси...",
      refreshing: "Обновяване…",
      noTablesFound: 'Не са намерени маси, съответстващи на "{query}"',
      startNewDay: "Започни нов ден",
      startNewDayConfirm: "Това ще нулира всички маси до статус СВОБОДНА. Това действие не може да бъде отменено.",
      startNewDayWarning: "Предупреждение: Всички статуси на маси ще бъдат нулирани до СВОБОДНА. Активните поръчки ще останат запазени, но масите ще бъдат маркирани като налични.",
      resetAllTables: "Нулирай всички маси",
      numberOfGuests: "Брой гости",
      howManyGuests: "\u041a\u043e\u043b\u043a\u043e \u0433\u043e\u0441\u0442\u0438?",
      orEnterCustom: "Или въведете персонализиран брой",
      maximumGuests: "Максимум: 20 гости",
      startOrder: "Започни поръчка",
      openTable: "Отвори маса",
      mergeTables: "Обедини маси",
      mergeTablesTitle: "Обедини маси",
      selectTablesToMerge: "Изберете маси за обединяване с {tableName}",
      combinedCapacity: "Общ капацитет: {capacity}",
      noFreeTablesToMerge: "Няма свободни маси за обединяване",
      confirmMerge: "Обедини и отвори",
      mergedWith: "Обединена с {tables}",
      keepMergedQuestion: "Запази обединението?",
      keepMergedDescription: "Искате ли масите да останат обединени за следващата поръчка, или да ги разделите?",
      keepMerged: "Запази обединени",
      splitTables: "Раздели масите",
      tableMergedRedirect: "Тази маса е обединена с {primaryTable}. Отваряне на поръчката.",
      moveGuests: "Премести гости",
      moveGuestsInstruction: "Натиснете масата, от която да преместите",
      moveGuestsDestInstruction: "Сега натиснете масата, към която да преместите",
      moveGuestsConfirmTitle: "Премести гости",
      moveGuestsConfirmMessage: "Преместване на всички поръчки от {source} към {destination}?",
      moveGuestsSuccess: "Гостите са преместени от {source} към {destination}",
      moveGuestsSelectOccupied: "Изберете заета маса с гости",
      mergeTablesInstruction: "Натиснете ОСНОВНАТА маса за обединяване",
      mergeTablesSecondaryInstruction: "Натиснете маси за добавяне, след това потвърдете",
      mergeTablesConfirmTitle: "Обедини маси",
      mergeTablesConfirmMessage: "Обединяване на {tables}? Всички поръчки ще се преместят към {primary}.",
      mergeTablesConfirmButton: "Обедини",
      mergeTablesSuccess: "Масите са обединени успешно",
      cancelSelection: "Отказ",
      confirmSelection: "Потвърди",
      editLayout: "Редактирай наредбата",
      saveLayout: "Запази наредбата",
      savingLayout: "Запазване...",
      cancelLayout: "Отказ",
      layoutEditBanner: "Режим на редактиране — плъзнете масите за да ги преместите, след това натиснете",
      seat: "място",
      seats: "места",
      pleaseEnterTableName: "Моля, въведете име на маса",
      pleaseEnterValidGuests: "Моля, въведете валиден брой гости (1-20)",
      tableAlreadySeated: "Масата вече е заета",
      openOrderToEdit: "Отворете поръчката, за да редактирате гости или артикули.",
      actionNotAllowed: "Действието не е разрешено",
      finishOrVoidBeforeCleaning: "Маса {tableName} е {state}. Завършете или анулирайте сметката преди почистване.",
      openOrder: "Отвори поръчка",
      confirmTableCleaned: "\u041f\u043e\u0442\u0432\u044a\u0440\u0434\u0435\u0442\u0435, \u0447\u0435 \u043c\u0430\u0441\u0430 {tableName} \u0435 \u043f\u043e\u0447\u0438\u0441\u0442\u0435\u043d\u0430?",
      unableToDetermineVenue: "Не може да се определи заведението. Моля, влезте отново.",
      unknown: "Неизвестно",
      timerType: "Тип таймер",
      noTimer: "Без таймер",
      timerUpdated: "Настройката на таймера е обновена",
      floor: "Зона",
      noFloor: "Без зона",
      addFloor: "Добави зона",
      newFloorName: "Име на зона:",
      renameFloor: "Преименувай зона:",
      mainFloor: "Основна",
      deleteZoneConfirm: "Изтриване на \"{name}\"? Масите ще се върнат в Основна.",
    },
    // Order Screen
    orderScreen: {
      back: "← Назад",
      discounts: "Отстъпки",
      guests: "Гости:",
      assignToGuest: "Присвои на гост",
      current: "Текущ:",
      guestNumber: "Гост {number}",
      food: "Храна",
      drinks: "Напитки",
      extras: "Екстри",
      all: "Всички",
      appetizers: "Предястия",
      main: "Основни",
      dessert: "Десерти",
      sides: "Гарнитури",
      cocktails: "Коктейли",
      softDrinks: "Безалкохолни",
      beers: "Бири",
      whiskey: "Уиски",
      liquors: "Ликьори",
      wine: "Вино",
      customCocktails: "Персонализирани коктейли",
      other: "Други",
      loadingMenu: "Зареждане на меню от сървъра...",
      retryNow: "Опитай сега",
      loadingMenuItems: "Зареждане на меню...",
      noProducts: "Няма налични продукти",
      noProductsDesc: "Моля, проверете по-късно или се свържете с поддръжката",
      noItemsInCategory: "Няма артикули в тази категория",
      searchProducts: "Търси продукти...",
      noSearchResults: 'Няма резултати за "{query}"',
      clearSearch: "Изчисти търсенето",
      favourites: "Любими",
      itemAdded: "{name} добавено в поръчката",
      lastOrderRepeated: "Последната поръчка повторена",
      noPreviousOrder: "Няма предишна поръчка за повторение",
      tableCleared: "Масата е изчистена",
      orderReset: "Поръчката е нулирана",
      resetOrder: "Нулирай поръчка",
      resetOrderConfirm: "Това ще изчисти всички артикули от поръчката. Моля, предоставете причина.",
      resetReasonPlaceholder: "Въведете причина (напр., Клиентът отмени, Грешна поръчка и т.н.)",
      itemRemoved: "{name} премахнато от поръчката",
      itemRemovedWithReason: "{name} премахнато (Причина: {reason})",
      failedToRemove: "Неуспешно премахване на артикул. Моля, опитайте отново.",
      addItemsFirst: "Първо добавете артикули в поръчката",
      selectItemsToFire: "Моля, изберете артикули за изпращане",
      menuLoading: "Менюто все още се зарежда. Моля, изчакайте малко и опитайте отново.",
      cannotFireInvalid: "Не може да се изпратят невалидни артикули: {names}",
      alreadyInProgress: "Избраните артикули вече са в процес или готови",
      itemsFired: "{count} артикул(а) изпратени! Артикулите са маршрутизирани по категория",
      printFailed: "Печатът неуспешен — проверете принтера",
      fireOrder: "Изпрати поръчка",
      requestPayment: "Заяви плащане",
      pleaseFireFirst: "Моля, първо изпратете поръчката",
      unfiredItemsWarning: "{count} артикул(а) все още не са изпратени. Моля, изпратете всички артикули преди плащане.",
      itemStatusUpdated: "Статусът на артикула е актуализиран до {status}",
      failedToUpdateStatus: "Неуспешна актуализация на статуса на артикула",
      item: "артикул",
      items: "артикули",
      pleaseEnterReason: "Моля, въведете причина",
      noValidItemsToFire: "Няма валидни артикули за изпращане",
      cannotFireInProgress: "Не може да се изпратят артикули, които вече са в процес или готови",
      table: "Маса",
      order: "Поръчка",
      guest: "гост",
      guests: "гости",
      noItemsInOrder: "Няма артикули в поръчката",
      clearTable: "Изчисти маса",
      repeatLastOrder: "Повтори последна поръчка",
      removeItem: "Премахни артикул",
      changeDiscount: "Промени отстъпка",
      applyDiscount: "Приложи отстъпка",
      selectAll: "Избери всички",
      deselectAll: "Отмени избора ({count} избрани)",
      sendingOrder: "Изпращане на поръчка...",
      fire: "Изпрати",
      fireOrder: "Изпрати поръчка",
      itemsFiredShort: "✓ Артикулите са изпратени",
      subtotal: "Междинна сума",
      tax: "Данък (10%)",
      total: "Общо",
      qty: "Кол.",
      each: "бр.",
      statusPending: "ПОРЪЧАНО",
      statusInProgress: "В ПРОЦЕС",
      statusReady: "ГОТОВО",
      statusCancelled: "ОТМЕНЕНО",
      customizeOrder: "Персонализирайте поръчката си",
      noCustomizationOptions: "Няма налични опции за персонализиране",
      optionalAddOns: "Допълнителни добавки",
      requiredSelectOption: "Задължително - Изберете опция",
      totalPrice: "Обща цена:",
      next: "Напред →",
      addToOrder: "Добави в поръчката",
    },
    // Remove Item Modal
    removeItemModal: {
      removeItem: "Премахни артикул",
      removeFromOrder: "Премахни",
      fromOrder: "от поръчката",
      reason: "Причина",
      selectReason: "Изберете причина",
      reasonWrongItem: "Грешен артикул",
      reasonCustomerCancelled: "Клиентът отмени",
      reasonAlreadyOrdered: "Вече поръчано",
      reasonUnavailable: "Артикулът не е наличен",
      reasonOther: "Друго",
      specifyReason: "Моля, посочете причината",
      pleaseEnterReason: "Моля, въведете причина за премахване на този артикул",
      managerApprovalRequired: "Необходимо е одобрение от мениджър за премахване на този артикул",
      managerApprovalRequiredTitle: "Необходимо одобрение от мениджър",
      managerApprovalConfirm: "Потвърждавам, че мениджърът е одобрил премахването на този артикул",
      managerRequiredBlocked: "Само мениджър може да премахне този артикул",
      managerRequiredBlockedDesc: "Анулирането на поръчани артикули е ограничено до мениджъри в настройките на обекта.",
    },
    // Payment Screen
    paymentScreen: {
      payment: "Плащане",
      subtotal: "Междинна сума",
      tax: "Данък (10%)",
      tip: "Бакшиш",
      total: "Общо",
      selectPaymentMethod: "Изберете метод на плащане",
      cash: "В брой",
      card: "Карта",
      mixed: "Смесено",
      amountGiven: "Дадена сума",
      change: "Ресто",
      selectTip: "Изберете бакшиш",
      customTip: "Персонализиран бакшиш",
      noTip: "Без бакшиш",
      processPayment: "Обработи плащането",
      noOrderToPayFor: "Няма поръчка — моля, изпратете артикулите преди да продължите към плащане",
      selectPaymentMethodFirst: "Моля, изберете метод на плащане",
      cashShort: "Получената сума в брой ({currency} {amount}) е по-малка от общата (€{total}).",
      invalidSplitCount: "Невалиден брой за разделяне",
      invalidSplitAmount: "Невалидна сума за разделяне",
      processing: "Обработване...",
      paymentProcessed: "Плащането е обработено успешно",
      showReceipt: "Покажи касова бележка",
      receipt: "Касова бележка",
      printReceipt: "Принтирай касова бележка",
      close: "Затвори",
      noItemsInOrder: "Няма артикули в поръчката",
      returnToTables: "Върни се към масите",
      backToOrder: "← Назад към поръчката",
      billSummary: "Резюме на сметката",
      splitPayment: "Разделено плащане",
      splitPaymentDesc: "Активирайте, за да разделите сметката между няколко души",
      enableSplit: "Активирай разделяне",
      disable: "Деактивирай",
      evenSplit: "Равно разделяне",
      byGuest: "По гост",
      numberOfPeople: "Брой души:",
      peopleCount: "{count} души",
      peopleSummary: "{count} души",
      guestsSummary: "{count} гости",
      amountPerPersonDisplay: "€{amount} на човек",
      cashCurrency: "Валута на парите в брой",
      changeEquivalentBGN: "Еквивалент на рестото в BGN",
      cashLessThanTotal: "Парите в брой (конвертирани в EUR) са по-малко от общата сума на сметката — моля, коригирайте сумата.",
      orderItems: "Артикули от поръчката",
      guest: "Гост",
      paymentProcessedSuccess: "Плащането е обработено и масата е изчистена успешно",
      paymentProcessedButNoTableUpdate: "Плащането е обработено, но не може да се актуализира статусът на масата",
      paymentFailed: "Плащането не бе успешно. Моля, опитайте отново.",
      printingFiscalReceipt: "Печат на фискална бележка...",
      fiscalReceiptPrinted: "Фискална бележка #{receiptNo} отпечатана",
      fiscalPrintFailed: "Грешка при фискална бележка: {error}",
      retryFiscal: "Опитай отново",
      skipFiscal: "Пропусни (само мениджър)",
      skipFiscalPaymentDone: "Продължи — плащането е записано",
      printPreBill: "Принт сметка",
      // Article split
      splitByItem: "По артикул",
      assignItems: "Разпределете артикулите по гости",
      unassignedItems: "{count} неразпределен(и) артикул(а)",
      assigned: "разпределен(и)",
      noItemsAssigned: "Все още няма разпределени артикули",
      guestBill: "Гост {number}",
      payGuest: "Плати за Гост {number}",
      guestPaid: "Гост {number} плати!",
      guestPaidLabel: "Гост {number} - Платено",
      allGuestsPaid: "Всички гости платиха!",
      assignAllTo: "Всичко → Гост {number}",
      tipShare: "Дял от бакшиш",
      proceedToPayment: "Продължи към плащане",
      guestProgress: "Гост {current} от {total}",
      cannotCancelMidSplit: "Завършете плащанията на всички гости, за да затворите сметката",
      backToAssignment: "← Обратно към разпределяне",
    },
    // Settings
    settings: {
      venueSettings: "Настройки на заведението",
      venueSettingsDesc: "Актуализирайте оперативните предпочитания за залата, персонала и отчетите.",
      settingsSaved: "Настройките са запазени {time}",
      floorOperations: "Операции на залата",
      floorOperationsDesc: "Контролирайте как залата се актуализира и обработва автоматични преходи.",
      autoCloseChecks: "Автоматично затваряне на сметки след плащане",
      autoCloseChecksDesc: "Автоматично маркирайте масите като СВОБОДНИ след като плащането е прихванато.",
      requirePin: "Изискване на персонален PIN при редактиране на поръчки",
      requirePinDesc: "Поискайте назначения персонален PIN преди модифициране на отворена сметка.",
      staffPermissions: "Права на персонала",
      staffPermissionsDesc: "Контролирайте кои действия може да извършва персоналът, който не е мениджър.",
      voidRequiresManager: "Анулирането изисква мениджър",
      voidRequiresManagerDesc: "Когато е включено, само мениджъри, собственици и администратори могат да анулират или сторнират поръчки. Сервитьорите ще бъдат блокирани.",
      floorRefreshCadence: "Честота на обновяване на залата",
      floorRefreshCadenceMinutes: "(минути)",
      notificationsTheme: "Известия и тема",
      notificationsThemeDesc: "Бъдете информирани за сигнали за склад, персонал и статистика.",
      inventoryAlerts: "Сигнали за склад",
      inventoryAlertsDesc: "Уведомявайте мениджърите, когато наличността падне под нивото на пар.",
      staffingReminders: "Напомняния за персонал",
      staffingRemindersDesc: "Изпращайте напомняния за предстоящи смени или когато почивките надхвърлят лимитите.",
      analyticsDigests: "Статистически резюмета",
      analyticsDigestsDesc: "Доставяйте дневни резюмета за производителността по имейл.",
      darkMode: "Тъмен режим на интерфейса",
      darkModeDesc: "Запазете Quantbar в тема, приятелска към слабата светлина.",
      restaurantLogout: "Изход от заведението",
      restaurantLogoutDesc: "Излезте от заведението и се върнете към екрана за вход. Ще трябва отново да въведете PIN на заведението, за да получите достъп до това заведение.",
      loggingOut: "Излизане...",
      restaurantLogoutButton: "Изход от заведението",
      logoutConfirm: "\u0421\u0438\u0433\u0443\u0440\u043d\u0438 \u043b\u0438 \u0441\u0442\u0435, \u0447\u0435 \u0438\u0441\u043a\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u043b\u0435\u0437\u0435\u0442\u0435 \u043e\u0442 \u0437\u0430\u0432\u0435\u0434\u0435\u043d\u0438\u0435\u0442\u043e? \u0429\u0435 \u0442\u0440\u044f\u0431\u0432\u0430 \u043e\u0442\u043d\u043e\u0432\u043e \u0434\u0430 \u0432\u044a\u0432\u0435\u0434\u0435\u0442\u0435 PIN \u043d\u0430 \u0437\u0430\u0432\u0435\u0434\u0435\u043d\u0438\u0435\u0442\u043e, \u0437\u0430 \u0434\u0430 \u043f\u043e\u043b\u0443\u0447\u0438\u0442\u0435 \u0434\u043e\u0441\u0442\u044a\u043f \u0434\u043e \u0442\u043e\u0432\u0430 \u0437\u0430\u0432\u0435\u0434\u0435\u043d\u0438\u0435.",
      language: "Език",
      languageDesc: "Променете езика на интерфейса",
      english: "English",
      bulgarian: "Български",
      fiscalPrinter: "Фискален принтер",
      fiscalPrinterDesc: "Datecs FP-700/FP-800 за фискални касови бележки.",
      fiscalPrinterPort: "COM порт",
      fiscalOperatorPassword: "Парола на оператора",
      testConnection: "Тест връзка",
      connected: "Свързан",
      disconnected: "Изключен",
      kitchenPrinter: "Кухненски принтер",
      kitchenPrinterDesc: "ESC/POS принтер за кухненски билети.",
      kitchenPrinterIp: "IP адрес на принтера",
      myVenues: "Моите заведения",
      myVenuesDesc: "Преглеждайте данните от другите си заведения. Устройството остава на {venue}.",
      myVenuesHome: "основно",
      myVenuesViewing: "преглежда се",
      myVenuesBackTo: "Обратно към {venue}",
      viewingBanner: "Преглеждате {venue}",
      viewingBannerDesc: "Показаните данни са от това заведение. Устройството ви все още е на {home}.",
    },
    // Print Configuration
    printConfig: {
      title: "Принт станции",
      description: "Конфигурирайте термални принтери и маршрутизирайте поръчките към кухня, бар или други станции.",
      autoPrint: "Автоматичен печат при изпращане",
      autoPrintDesc: "Автоматично печатане на билети при изпращане на артикули.",
      printers: "Принтери",
      addPrinter: "Добави принтер",
      noPrinters: "Няма конфигурирани принтери.",
      printerName: "Име",
      ipAddress: "IP адрес",
      port: "Порт",
      testing: "Тестване...",
      testOk: "Принтерът е свързан",
      testFailed: "Връзката неуспешна",
      saveFailed: "Грешка при запазване на конфигурацията",
      addPrinterFirst: "Първо добавете принтер",
      stations: "Станции",
      addStation: "Добави станция",
      noStations: "Няма конфигурирани станции.",
      stationName: "Име на станция",
      linkedPrinter: "Принтер",
      copies: "Копия",
      routing: "Маршрутизиране на поръчки",
      routingDesc: "Изберете кои категории от менюто се печатат на коя станция.",
      category: "Категория",
      legacySettings: "Стари настройки на принтер (единичен IP)",
      dietaryFlagsSection: "Диетични / Алергенни флагове",
      dietaryFlagsSectionDesc: "Дефинирайте флагове за диетични нужди или алергени. Показват се на артикулите и се печатат на бележките.",
      noDietaryFlags: "Няма персонализирани флагове — използват се стандартните.",
      addFlag: "Добави",
      flagLabelPlaceholder: "напр. Халал, Кошер, Без глутен...",
    },
    // Item Notes & Dietary Flags
    itemNotes: {
      title: "Бележки и флагове",
      dietaryFlags: "Диетични / Алергени",
      freeNotes: "Специални инструкции",
      placeholder: "напр. добре изпечено, без сос, много люто...",
      glutenFree: "Без глутен",
      dairyFree: "Без млечни",
      nutFree: "Без ядки",
      vegan: "Веган",
      vegetarian: "Вегетарианско",
      spicy: "Много люто",
      noSpice: "Без люто",
      allergy: "Алергия",
    },
    // Inventory
    inventory: {
      inventory: "Склад",
      addItem: "Добави артикул",
      editItem: "Редактирай артикул",
      itemName: "Име на артикула",
      category: "Категория",
      unit: "Мерна единица",
      quantity: "Количество",
      parLevel: "Целево ниво",
      minimumQuantity: "Минимално количество",
      useBottles: "Използвай бутилки",
      directQuantity: "Директно количество",
      bottleSize: "Размер на бутилка (мл)",
      numberOfBottles: "Брой бутилки",
      save: "Запази",
      cancel: "Отказ",
      delete: "Изтрий",
      deleteItem: "Изтрий артикул",
      deleteItemConfirm: "Сигурни ли сте, че искате да изтриете {name}?",
      critical: "Критично",
      warning: "Предупреждение",
      healthy: "Здравословно",
      noItems: "Не са намерени артикули в склада",
      loading: "Зареждане на склад...",
      failedToLoad: "Неуспешно зареждане на склад",
      itemSaved: "Артикулът е запазен успешно",
      itemDeleted: "Артикулът е изтрит успешно",
      failedToSave: "Неуспешно запазване на артикул",
      failedToDelete: "Неуспешно изтриване на артикул",
      pleaseEnterItemName: "Моля, въведете име на артикул",
      pleaseAddBottleEntry: "Моля, добавете поне един запис за бутилка",
      pleaseEnterQuantity: "Моля, въведете количество",
      pleaseEnterBottles: "Моля, въведете брой бутилки",
      selectCategory: "Изберете категория",
      selectSize: "Изберете размер",
      custom: "Персонализиран",
      customMl: "Персонализиран (ml)",
      count: "Брой",
      remove: "Премахни",
      totalQuantity: "Общо количество",
      enterQuantity: "Въведете количество",
      negativeHint: "Използвайте отрицателни числа за изваждане (напр. -3 за ползвани преди доставката)",
      parLevelBottles: "Целево ниво (бутилки)",
      parLevel: "Целево ниво (целево количество)",
      parLevelBottlesPlaceholder: "напр., 5 бутилки",
      optional: "По избор",
      minimumQuantityBottles: "Минимално количество (бутилки)",
      minimumQuantity: "Минимално количество (праг за сигнал)",
      minimumQuantityBottlesPlaceholder: "напр., 2 бутилки",
      addQuantity: "Добави количество",
      item: "Артикул",
      quantityAddedSuccess: "Количеството е добавено успешно",
      deleteItemConfirm: "Изтрий {name}? Това не може да бъде отменено.",
      totalItems: "Общо артикули",
      criticalAlerts: "Критични сигнали",
      belowMinimum: "Под минимума",
      allGood: "Всичко е наред",
      warnings: "Предупреждения",
      belowParLevel: "Под целевото ниво",
      atOrAbovePar: "На или над целевото ниво",
      accessDenied: "Достъп отказан",
      accessDeniedDesc: "Нямате разрешение да виждате инвентара.",
      inventoryManagement: "Управление на инвентар",
      inventoryManagementDesc: "Проследявайте и управлявайте артикулите в инвентара",
      activeAlerts: "Активни сигнали",
      acknowledge: "Признай",
      loadingInventory: "Зареждане на инвентар...",
      noInventoryMatches: "Няма артикули, съответстващи на \"{query}\".",
      noInventoryItems: "Все още няма артикули в инвентара",
      addFirstItem: "Добавете първия си артикул",
      quantityInputMethod: "Метод за въвеждане на количество",
      byBottles: "По бутилки (за течности)",
      bottleEntries: "Записи за бутилки (може да се добавят множество размери)",
      addEntry: "+ Добави запис",
      items: "артикули",
      uncategorized: "Без категория",
      onHand: "Налично",
      par: "Целево",
      min: "Мин.",
      quickAdd: "+ Добави",
      numberOfBottles: "Брой бутилки",
      errorLoading: "Грешка при зареждане на инвентар:",
      error404Message: "API крайната точка за инвентар може да не е налична. Моля, проверете дали сървърът работи и миграцията е приложена.",
      errorConnectionMessage: "Моля, проверете връзката си и опитайте да обновите страницата.",
      unitMl: "ml (милилитри)",
      unitG: "g (грамове)",
      unitKg: "kg (килограми)",
      unitLiters: "L (литри)",
      unitPieces: "бр.",
      unitEach: "бр.",
      categorySpirits: "Алкохоли",
      categoryMixers: "Миксери",
      categorySyrups: "Сиропи",
      categoryFood: "Храна",
      categoryProduce: "Плодове и зеленчуци",
      categoryProteins: "Протеини",
      categoryDairy: "Млечни продукти",
      categoryOther: "Други",
      itemNamePlaceholder: "напр., Абсолют Водка, Кампари",
      alertAcknowledged: "Сигналът е признат",
      failedToAcknowledge: "Неуспешно признаване на сигнал",
      threshold: "праг",
      linked: "Свързан",
      unableToLoad: "Инвентарът не може да се зареди",
      current: "Текущо",
      itemSingular: "артикул",
      itemPlural: "артикула",
      bottle: "бутилка",
      restock: "Зареди",
      failedToRestock: "Неуспешно зареждане на наличност",
      enterPositiveQuantity: "Въведете количество за зареждане, по-голямо от 0.",
      currentStock: "Текуща наличност",
      quantityToAdd: "Количество за добавяне",
      notes: "Бележки",
      optionalRestockNote: "Незадължителна бележка за зареждане",
      restocking: "Зареждане...",
      deduct: "Приспадане",
      quantityToDeduct: "Количество за приспадане",
      optionalDeductNote: "Незадължителна бележка за приспадане",
      deducting: "Приспадане...",
      failedToDeduct: "Неуспешно приспадане от инвентара",
      cannotDeductMoreThanStock: "Не може да приспаднете повече от текущото количество.",
      readOnlyMobileNonManagers: "Само за преглед в мобилното приложение за служители без мениджърски права.",
      liveSchemaDescription: "Използва текущата схема за инвентар от сървъра и миграциите.",
      categoryPlaceholder: "алкохоли, миксери, храна...",
      // Multi-location
      locations: "Локации",
      addLocation: "Добави локация",
      editLocation: "Редактирай локация",
      deleteLocation: "Изтрий локация",
      defaultLocation: "По подразбиране",
      setAsDefault: "Задай по подразбиране",
      transferStock: "Прехвърли наличност",
      transferFrom: "От",
      transferTo: "Към",
      transferQuantity: "Количество за прехвърляне",
      transferred: "Наличността е прехвърлена",
      trackByLocation: "Проследяване по локация",
      trackByLocationDesc: "Разделяне на наличностите между различни складови локации",
      combinedMode: "Общо",
      splitMode: "Разделено по локация",
      noLocations: "Няма конфигурирани локации",
      addFirstLocation: "Добавете първата си локация за да започнете",
      locationBreakdown: "Разпределение по локации",
      modeChangeWarning: "Промяната на режима ще реорганизира данните за наличностите",
      createLocationFirst: "Създайте поне една локация преди да активирате разделен режим",
      locationNamePlaceholder: "напр. Бар, Склад, Кухня",
      allLocations: "Всички локации",
      selectLocation: "Изберете локация",
      locationDeleted: "Локацията е изтрита",
      locationCreated: "Локацията е създадена",
      locationUpdated: "Локацията е обновена",
      cannotDeleteWithStock: "Прехвърлете цялата наличност преди да изтриете локацията",
      // Locations
      manageLocations: "Локации",
      locationsDesc: "Организирайте наличностите в активни (бар) и резервни (склад) локации",
      locTypeActive: "Активна",
      locTypeReserve: "Резервна",
      noLocations: "Няма локации все още",
      defaultLocation: "По подразбиране",
      setDefault: "Направи основна",
      // Cost & Waste
      costPrice: "Цена",
      waste: "Брак",
      recordWaste: "Запиши брак",
      wasteRecorded: "Бракът е записан успешно",
      wasteQuantityPlaceholder: "Количество за брак",
      selectWasteReason: "Изберете причина...",
      wasteExpired: "Изтекъл срок",
      wasteSpoiled: "Развалено",
      wasteDamaged: "Повредено",
      wasteSpilled: "Разлято",
      wasteQuality: "Проблем с качеството",
      wasteOther: "Друго",
      each: "бр.",
      searchPlaceholder: "Търсене в склада...",
    },
    menu: {
      pinToFavourites: "Закачи към любими",
      removeFromFavourites: "Премахни от любими",
      itemCode: "Код на артикул / SKU",
      itemCodePlaceholder: "напр. ESP001",
      autoGenerate: "Автоматично",
      codeDuplicate: "Този код вече се използва",
    },
    // Menu Management
    menuManagement: {
      menuManagement: "Управление на меню",
      addMenuItem: "Добави артикул в менюто",
      editMenuItem: "Редактирай артикул в менюто",
      itemName: "Име на артикула",
      category: "Категория",
      subcategory: "Подкатегория",
      price: "Цена",
      description: "Описание",
      ingredients: "Съставки",
      addIngredient: "Добави съставка",
      save: "Запази",
      cancel: "Отказ",
      delete: "Изтрий",
      deleteItem: "Изтрий артикул от менюто",
      deleteItemConfirm: "Сигурни ли сте, че искате да изтриете {name}?",
      noItems: "Не са намерени артикули в менюто",
      loading: "Зареждане на артикули от менюто...",
      failedToLoad: "Неуспешно зареждане на артикули от менюто",
      itemSaved: "Артикулът от менюто е запазен успешно",
      itemDeleted: "Артикулът от менюто е изтрит успешно",
      failedToSave: "Неуспешно запазване на артикул от менюто",
      failedToDelete: "Неуспешно изтриване на артикул от менюто",
      missingVenueInfo: "Липсва информация за заведението. Моля, влезте отново.",
      goToLogin: "Отиди на вход",
      manageMenuItemsAndIngredients: "Управлявайте артикули от менюто и съставки",
      all: "Всички",
      searchMenuItems: "Търсене в менюто",
      managerAccessRequiredMobile: "Нужен е мениджърски достъп в мобилното приложение.",
      itemsLabel: "Артикули",
      customizable: "Персонализируеми",
      addFirstMenuItem: "Добавете първия си артикул в менюто",
      dragToReorder: "Плъзнете артикулите, за да ги пренаредите. Кликнете \"Запази ред\", за да приложите промените.",
      saveOrder: "Запази ред",
      orderLabel: "Ред",
      moveUp: "Нагоре",
      moveDown: "Надолу",
      noDescription: "Няма описание",
      itemDeletedToast: "{name} изтрит",
      itemUpdatedToast: "{name} актуализиран",
      itemAddedToast: "{name} добавен в менюто",
      menuOrderSaved: "Редът на менюто е запазен успешно",
      failedToSaveOrder: "Неуспешно запазване на реда на менюто",
      categoryFood: "Храна",
      categoryDrinks: "Напитки",
      categoryExtras: "Екстри",
      subcategoryAppetizers: "Предястия",
      subcategoryMain: "Основни",
      subcategoryDessert: "Десерти",
      subcategorySides: "Гарнитури",
      subcategoryOther: "Други",
      subcategoryCocktails: "Коктейли",
      subcategorySoftDrinks: "Безалкохолни",
      subcategoryBeers: "Бири",
      subcategoryWhiskey: "Уиски",
      subcategoryLiquors: "Ликьори",
      subcategoryWine: "Вино",
      subcategoryCustomCocktails: "Персонализирани коктейли",
      unit: "Мерна единица",
      itemNamePlaceholder: "Име на артикул от менюто",
      unitPlaceholder: "бр., порция, мл, г и т.н.",
      descriptionPlaceholder: "Описание на артикула...",
      selectInventoryItem: "Изберете артикул от склада",
      qtyPerOrder: "Кол./поръчка",
      qtyPerOrderTooltip: "Количество, използвано на поръчка (напр., 50 мл на порция)",
      loadingInventoryItems: "Зареждане на артикули от склада...",
      noInventoryItemsAvailable: "Няма налични артикули от склада за {category}. Първо добавете артикули в страницата Склад.",
      thisCategory: "тази категория",
      noIngredientsAdded: "Няма добавени съставки. Кликнете \"Добави съставка\", за да свържете артикули от склада.",
      removeIngredient: "Премахни съставка",
      enableCustomizationOptions: "Активирай опции за персонализиране",
      customizationDescription: "Добавете групи модификатори за персонализируеми артикули.",
      useTemplate: "Използвай шаблон",
      customSetup: "Персонализирана настройка",
      templateGinTonic: "Джин и тоник",
      templateSpritz: "Шприц",
      templateMartini: "Мартини",
      templateOldFashioned: "Олд Фешънд",
      templateNegroni: "Негрони",
      selectTemplate: "Изберете шаблон...",
      applyTemplate: "Приложи шаблон",
      modifierGroups: "Групи модификатори",
      addModifierGroup: "Добави група модификатори",
      modifierGroupN: "Група модификатори {n}",
      modifierLabelPlaceholder: "Етикет на модификатор (напр., Избери джин)",
      required: "Задължително",
      orderTooltip: "Ред (1 = първо, 2 = второ и т.н.)",
      priceChange: "Промяна в цената",
      removeModifierGroup: "Премахни група модификатори",
      options: "Опции",
      populateFromInventory: "Попълни от склад",
      spirits: "Алкохоли",
      mixers: "Миксери",
      syrups: "Сиропи",
      softDrinks: "Безалкохолни напитки",
      addOption: "Добави опция",
      aperol: "Аперол",
      gin: "Джин",
      vodka: "Водка",
      dry: "Сух",
      sweet: "Сладък",
      olive: "Маслина",
      lemonTwist: "Лимонова кора",
      angostura: "Ангостура",
      orange: "Портокал",
      sugarCube: "Бучка захар",
      simpleSyrup: "Захарен сироп",
      standard: "Стандартно",
      selectGin: "Избери джин",
      selectTonic: "Избери тоник",
      selectWineProsecco: "Избери вино/просеко",
      selectAperitif: "Избери аперитив",
      sodaWater: "Сода",
      selectSpirit: "Избери алкохол",
      selectVermouth: "Избери вермут",
      garnish: "Гарнитура",
      selectWhiskey: "Избери уиски",
      bitters: "Горчивки",
      sweetener: "Подсладител",
      campari: "Кампари",
      optionName: "Име на опцията",
      removeOption: "Премахни опция",
      noOptions: "Няма опции. Добавете поне една опция.",
      updateItem: "Актуализирай артикул",
      addItem: "Добави артикул",
      pleaseEnterItemName: "Моля, въведете име на артикул от менюто",
      pleaseEnterValidPrice: "Моля, въведете валидна цена",
      newModifier: "Нов модификатор",
      option1: "Опция 1",
      optionN: "Опция {n}",
      none: "Няма",
      available: "налично",
      unitEach: "бр.",
      manageCategories: "Управление на категории",
      autoGenerate: "Автоматично",
      itemCode: "Код на артикул / SKU",
      itemCodePlaceholder: "напр. ESP001",
    },
    // Menu Categories
    menuCategories: {
      title: "Управление на категории",
      addCategory: "Нова категория",
      add: "Добави",
      addSubcategory: "Добави подкатегория",
      categoryNamePlaceholder: "напр. Десерти",
      subcategoryNamePlaceholder: "напр. Торти",
      categoryAdded: "Категорията е добавена",
      categorySaved: "Категорията е запазена",
      categoryDeleted: "Категорията е изтрита",
      subcategoryAdded: "Подкатегорията е добавена",
      subcategorySaved: "Подкатегорията е запазена",
      subcategoryDeleted: "Подкатегорията е изтрита",
      deleteCategoryConfirm: "Изтрий категория \"{name}\"? Това ще изтрие и всички нейни подкатегории.",
      deleteSubcategoryConfirm: "Изтрий подкатегория \"{name}\"?",
      failedToLoad: "Неуспешно зареждане на категории",
      failedToSave: "Неуспешно запазване",
      failedToDelete: "Неуспешно изтриване",
    },
    // Staff
    staff: {
      teamRoster: "Персонален състав",
      teamMember: "член на екипа",
      teamMembers: "члена на екипа",
      onDutyToday: "на смяна днес",
      hireStaff: "+ нов персонал",
      onDuty: "На смяна",
      off: "Извън смяна",
      noStaffFound: "Не са намерени членове на персонала.",
      noStaffRegistered: "Няма регистрирани членове на персонала за това заведение.",
      hireNewStaff: "Наеме нов член на персонала",
      firstName: "Име",
      lastName: "Фамилия",
      jobTitle: "Длъжност",
      department: "Отдел",
      role: "Роля",
      selectDepartment: "Изберете отдел",
      staff: "Персонал",
      manager: "Мениджър",
      staffMemberHired: "Член на персонала е нает!",
      staffMemberHiredDesc: "{name} е добавен към екипа.",
      saveCredentials: "Запазете тези идентификационни данни:",
      operatorCode: "Код на оператор:",
      pin: "PIN:",
      pinWarning: "⚠️ Този PIN няма да бъде показан отново. Моля, споделете го сигурно с члена на персонала.",
      gotIt: "Разбрах",
      fireStaff: "уволни член на персонала",
      fireStaffConfirm: "\u0421\u0438\u0433\u0443\u0440\u043d\u0438 \u043b\u0438 \u0441\u0442\u0435, \u0447\u0435 \u0438\u0441\u043a\u0430\u0442\u0435 \u0434\u0430 \u043e\u0441\u0432\u043e\u0431\u043e\u0434\u0438\u0442\u0435 {name}?",
      fireStaffDesc: "Това ще премахне техния PIN и деактивира техния акаунт, но техният код на оператор ще бъде запазен за одитни дневници.",
      fireStaffMember: "уволни член на персонала",
      staffMemberFired: "Член на персонала е освободен успешно",
      staffMemberHiredSuccess: "Член на персонала е нает успешно",
      failedToHire: "Неуспешно наемане на член на персонала",
      failedToFire: "Неуспешно освобождаване на член на персонала",
      accessDenied: "Достъпът е отказан",
      accessDeniedDesc: "Нямате разрешение да преглеждате управлението на персонала.",
      loadingRoster: "Зареждане на персонален състав...",
      service: "Обслужване",
      bar: "Бар",
      kitchen: "Кухня",
      frontDesk: "Рецепция",
      leadership: "Ръководство",
      all: "Всички",
      firstNameLastNameRequired: "Името и фамилията са задължителни",
      hire: "Наеме",
      fire: "уволни",
      clockIn: "влязъл в смяна",
      department: "Отдел",
      staffManagement: "Управление на персонала",
      editStaff: "Редактиране на персонал",
      editStaffMember: "Редактиране на член на персонала",
      updateStaff: "Актуализиране на персонал",
      staffMemberUpdated: "Член на персонала е актуализиран успешно",
      failedToUpdate: "Неуспешно актуализиране на член на персонала",
      changePosition: "Промяна на позиция",
      save: "Запази",
      cancel: "Отказ",
    },
    // Dashboard
    dashboard: {
      loadingDashboard: "Зареждане на табло...",
      venue: "Заведение {id}",
      updated: "Актуализирано {time}",
      refresh: "Обнови ↻",
      days: "дни",
      salesOverview: "Преглед на продажбите",
      noPriorData: "Няма предишни данни",
      vsYesterday: "{percent} спрямо вчера",
      revenue: "Приход",
      orders: "Поръчки",
      averageOrderValue: "Средна стойност на поръчка",
      completedTickets: "Завършени билети",
      revenuePerOrders: "Приход / Поръчки",
      hourlyRevenue: "Почасов приход",
      allVenues: "Всички заведения",
      topProducts: "Най-продавани продукти",
      total: "общо",
      paymentMix: "Смесица на плащания",
      breakdownByTenderType: "Разбивка по тип плащане",
      noPaymentsRecorded: "Няма записани плащания за този период.",
      payments: "плащания",
      tips: "бакшиши",
      vsLastWeek: "{percent} спрямо миналата седмица",
      // Alerts & Trends
      alertsTrends: "Сигнали и тенденции",
      critical: "Критични",
      warning: "Предупреждения",
      info: "Инфо",
      noAlertsInPeriod: "Няма сигнали за този период.",
      metric: "Метрика",
      forecast: "Прогноза",
      noForecastAvailable: "Няма налична прогноза.",
      // Financial Summary
      financialSummary: "Финансово обобщение",
      cogs: "Себестойност",
      grossMargin: "Брутен марж",
      sold: "продадени",
      cost: "цена",
      margin: "марж",
      noProductFinancials: "Няма финансови данни за продукти в този период.",
      tracked: "проследявани",
      // Inventory Snapshot
      inventorySnapshot: "Склад – моментна снимка",
      expectedQty: "Очаквано кол.",
      rollingTotalMovement: "Кумулативна сума от движения",
      countedQty: "Преброено кол.",
      latestStockCounts: "Последни инвентаризации",
      variance: "Разлика",
      units: "единици",
      avg: "Ср.",
      lowStock: "Ниска наличност",
      noLowStockAlerts: "Няма сигнали за ниска наличност за това заведение.",
      doc: "ДнП",
      restock: "Зареди",
      // Operational Timing
      operationalTiming: "Оперативно време",
      p50Prep: "P50 Подготовка",
      p90Prep: "P90 Подготовка",
      p50Total: "P50 Общо",
      tableTurnP50: "Оборот на маси (P50)",
      min: "мин",
      tableUtilization: "Използване на маси",
      tables: "маси",
      // Staff Leaderboard
      staffLeaderboard: "Класация на персонала",
      avgOrdersHr: "Ср. поръчки/час",
      avgTipsHr: "Ср. бакшиши/час",
      voids: "Анулирани",
      noShiftsRecorded: "Няма записани смени за този период.",
      ordHr: "пор./час",
      hr: "/час",
    },
    // Analytics
    analytics: {
      analytics: "Статистика",
      subtitle: "Проследявайте продажби, скорост на продуктите, рискове в склада и производителност на персонала.",
      accessDenied: "Достъп отказан",
      accessDeniedDesc: "Нямате разрешение да виждате статистиката.",
      revenueTrends: "Трендове на приходите",
      topSellingItems: "Най-продавани артикули",
      inventoryAlerts: "Сигнали за склад",
      staffPerformance: "Производителност на персонала",
      venue: "Заведение {id}",
      pageOf: "Страница {page} от {totalPages}",
      previous: "Предишна",
      next: "Следваща",
      unableToLoadRevenue: "Неуспешно зареждане на статистика за приходите.",
      totalRevenue: "Общ приход",
      totalOrders: "Общо поръчки",
      averageOrderValue: "Средна стойност на поръчка",
      prevPeriod: "Предишен: {revenue} ({change})",
      prevPeriodOrders: "Предишен: {orders} ({change})",
      revenuePerOrders: "Приход / Поръчки",
      summary: "Резюме",
      summaryDescription: "Основни метрики за избрания период.",
      revenueTrendsDescription: "{start} → {end} ({days} дни, групирани по {groupBy})",
      selectVenueAndRange: "Изберете заведение и период, за да видите производителността на приходите.",
      noRevenueData: "Не са намерени данни за приходите за избраните филтри.",
      revenue: "Приход",
      orders: "Поръчки",
      aov: "СПП",
      revenueBuckets: "Купи за приходи",
      revenueBucketsDescription: "Агрегирани приходи по времеви купи.",
      bucketStart: "Начало на куп",
      bucketEnd: "Край на куп",
      unableToLoadTopItems: "Неуспешно зареждане на най-продаваните артикули.",
      sortBy: "Сортирай по",
      quantity: "Количество",
      grossProfit: "Брутна печалба",
      marginPercent: "Марж %",
      averagePrice: "Средна цена",
      descending: "Низходящо",
      ascending: "Възходящо",
      search: "Търсене",
      filterByProductName: "Филтрирай по име на продукт",
      clear: "Изчисти",
      dateRangeDays: "{start} → {end} ({days} дни)",
      visualizeProductPerformance: "Визуализирай производителността на продукта по приход и количество.",
      noProductPerformanceData: "Няма данни за производителността на продукта за избраните филтри.",
      totalQuantity: "Общо количество",
      margin: "Марж",
      topItemsDetail: "Детайли за най-продаваните артикули",
      topItemsDetailDescription: "Детайлни метрики за приход, количество и рентабилност.",
      product: "Продукт",
      category: "Категория",
      avgPrice: "Средна цена",
      unableToLoadInventoryAlerts: "Неуспешно зареждане на сигнали за склад.",
      daysOfCoverThreshold: "Праг за дни покритие",
      variancePercentThreshold: "Праг за вариация %",
      inventoryAlertsBySeverity: "Сигнали за склад по тежест",
      monitorCriticalInventoryRisks: "Проследявай критични рискове в склада.",
      noInventoryAlertsDetected: "Не са открити сигнали за склад за избраните филтри.",
      alerts: "Сигнали",
      totalAlerts: "Общо сигнали",
      alertsFlaggedDuringPeriod: "Сигнали, маркирани през избрания период",
      inventoryAlertDetail: "Детайли за сигнали за склад",
      inventoryAlertDetailDescription: "Основни причини и класификация по тежест за всеки маркиран продукт.",
      severity: "Тежест",
      severityCritical: "Критично",
      severityWarning: "Предупреждение",
      severityInfo: "Информация",
      qty: "Кол.",
      reorderPoint: "Точка за поръчка",
      daysCover: "Дни покритие",
      variance: "Вариация",
      variancePercent: "Вариация %",
      lastCount: "Последно броене",
      reasons: "Причини",
      unableToLoadStaffAnalytics: "Неуспешно зареждане на статистика за персонала.",
      sortMetric: "Метрика за сортиране",
      compositeScore: "Композитен резултат",
      ordersPerHour: "Поръчки / час",
      tipsPerHour: "Бакшиши / час",
      voids: "Анулации",
      tips: "Бакшиши",
      hours: "Часове",
      range: "Период",
      dateRange: "{start} → {end}",
      selectVenue: "Изберете заведение",
      staffLeaderboard: "Класация на персонала",
      staffLeaderboardDescription: "Общ резултат за производителност, който награждава високи поръчки/час и бакшиши/час, и наказва висок брой анулации.",
      noStaffPerformanceRecorded: "Няма записана производителност на персонала за избраните филтри.",
      avgOrdersPerHour: "Средно поръчки/час",
      avgTipsPerHour: "Средно бакшиши/час",
      staffDetail: "Детайли за персонала",
      staffDetailDescription: "Детайлен преглед на поръчки, бакшиши, отработени часове и композитен резултат.",
      name: "Име",
      role: "Роля",
      ordersPerHourShort: "Поръчки/ч",
      tipsPerHourShort: "Бакшиши/ч",
      composite: "Композитен",
      groupBy: "Групирай по",
      day: "Ден",
      week: "Седмица",
      month: "Месец",
      allCategories: "Всички категории",
      loading: "Зареждане…",
      noDataAvailable: "Няма налични данни за избраните филтри.",
      noEntriesToDisplay: "Няма записи за показване.",
      sections: "Секции",
      previousPeriod: "Предишен период",
    },
    // Z Report (daily venue Z report)
    zReport: {
      title: "Дневен Отчет",
      subtitle: "Финансово обобщение в края на деня. Нулира дневните брояци.",
      failedToLoad: "Неуспешно зареждане на дневния отчет",
      print: "Печат на Дневен Отчет",
      receipts: "Брой касови бележки",
      revenueWithVat: "Оборот (с ДДС)",
      revenueNoVat: "Оборот (без ДДС)",
      vatTotal: "Общо ДДС",
      tips: "Бакшиши",
      discounts: "Отстъпки",
      voids: "Анулации",
      voidAmount: "Анулирана сума",
      paymentBreakdown: "Разбивка по плащания",
      vatBreakdown: "ДДС справка",
      vatRate: "ДДС ставка",
      netAmount: "Нето",
      vatAmount: "ДДС",
      grossAmount: "Бруто",
      period: "Период",
      noActivity: "Няма затворени продажби за тази дата.",
      cash: "В брой",
      card: "Карта",
      other: "Друго",
    },
    // My Report (daily staff report)
    myReport: {
      title: "Моят дневен отчет",
      subtitle: "Вашите дневни приходи, поръчки и калкулатор за бакшиш.",
      failedToLoad: "Неуспешно зареждане на дневния отчет",
      shift: "Смяна",
      ongoing: "текуща",
      noShift: "Няма записана смяна за този ден",
      revenue: "Приход",
      tips: "Бакшиши (записани)",
      orders: "Поръчки",
      voids: "Анулации",
      ordersPerHour: "Поръчки / час",
      hoursWorked: "Отработени часове",
      paymentBreakdown: "Разбивка по плащания",
      tipsLabel: "бакшиш",
      tipCalculator: "Калкулатор за бакшиш",
      tipCalculatorDesc: "Въведете общата сума в брой, която сте преброили, за да изчислите бакшиша. Приходът в брой се изважда, за да покаже вашите печалби.",
      cashRevenue: "Приход в брой (колко трябва да имате)",
      cashCounted: "Пари в брой, които преброихте",
      yourTips: "Вашият бакшиш от брой",
      shortage: "Липса",
      shortageDesc: "Трябва да добавите тази сума, за да покриете прихода.",
      noActivity: "Няма записана активност за този ден.",
    },
    // Discounts
    discounts: {
      discountManagement: "Управление на отстъпки",
      createDiscount: "Създай отстъпка",
      editDiscount: "Редактирай отстъпка",
      failedToLoad: "Неуспешно зареждане на отстъпки",
      pleaseEnterDiscountName: "Моля, въведете име на отстъпка",
      pleaseEnterValidDiscountValue: "Моля, въведете валидна стойност на отстъпка",
      percentageCannotExceed100: "Процентната отстъпка не може да надвишава 100%",
      discountUpdatedSuccessfully: "Отстъпката е актуализирана успешно",
      discountCreatedSuccessfully: "Отстъпката е създадена успешно",
      failedToUpdateDiscount: "Неуспешно актуализиране на отстъпка",
      failedToCreateDiscount: "Неуспешно създаване на отстъпка",
      discountActivated: "Отстъпката е активирана",
      discountDeactivated: "Отстъпката е деактивирана",
      loadingDiscounts: "Зареждане на отстъпки...",
      noDiscountsCreatedYet: "Все още няма създадени отстъпки",
      createFirstDiscount: "Създайте първата си отстъпка, за да започнете",
      deactivate: "Деактивирай",
      activate: "Активирай",
      inactive: "Неактивна",
      discountName: "Име на отстъпка",
      discountNamePlaceholder: "напр., Щастлив час, Студентска отстъпка",
      discountType: "Тип отстъпка",
      percentage: "Процент (%)",
      fixedAmount: "Фиксирана сума (€)",
      discountValue: "Стойност на отстъпка",
      enterValueBetween0And100: "Въведете стойност между 0 и 100",
      active: "Активна",
      update: "Актуализирай",
      create: "Създай",
      applyDiscount: "Приложи отстъпка",
      customAmount: "Персонализирана сума",
      enterDiscountAmount: "Въведете сума на отстъпка",
      selectDiscountOrEnterAmount: "Моля, изберете отстъпка или въведете сума",
      noActiveDiscounts: "Няма налични активни отстъпки",
      loadingDiscounts: "Зареждане на отстъпки...",
      discountApplied: "Отстъпката е приложена",
      customTip: "Персонализирана сума",
      pleaseEnterQuantity: "Моля, въведете количество",
      addedBottles: "Добавени {count} бутилки",
      manualAddition: "Ръчно добавяне",
    },
    // Apply Discount Modal
    applyDiscountModal: {
      applyDiscount: "Приложи отстъпка",
      customAmount: "Персонализирана сума",
      enterDiscountAmount: "Въведете сума на отстъпка",
      selectDiscountOrEnterAmount: "Моля, изберете отстъпка или въведете сума",
      noActiveDiscounts: "Няма налични активни отстъпки",
      loadingDiscounts: "Зареждане на отстъпки...",
      item: "Артикул",
      subtotal: "Междинна сума",
      discount: "Отстъпка",
      total: "Общо",
      cancel: "Отказ",
    },
    // Quick Add Modal
    quickAddModal: {
      pleaseEnterQuantity: "Моля, въведете количество",
      addedBottles: "Добавени {count} бутилки",
      manualAddition: "Ръчно добавяне",
    },
    // Audit Logs
    auditLogs: {
      auditLog: "Одит дневник",
      description: "Преглеждайте действия на потребители (вход, анулации, сторно, промени в конфигурацията) с филтри.",
      accessDenied: "Достъп отказан",
      accessDeniedDesc: "Нямате разрешение да преглеждате одит дневника.",
      failedToLoad: "Неуспешно зареждане на одит дневника",
      from: "От",
      to: "До",
      action: "Действие",
      all: "Всички",
      operatorCode: "Код на оператор",
      operatorCodePlaceholder: "напр. 0002",
      loading: "Зареждане...",
      showingEntries: "Показване на {count} от {total} записа",
      refresh: "Обнови",
      time: "Време",
      operator: "Оператор",
      details: "Детайли",
      noEventsFound: "Не са намерени одит събития за избраните филтри.",
      code: "Код",
      pageOf: "Страница {page} от {totalPages}",
      previous: "Предишна",
      next: "Следваща",
      actionLogin: "Вход",
      actionLogout: "Изход",
      actionSaleOpen: "Отваряне на продажба",
      actionItemAdd: "Добавяне на артикул",
      actionItemVoid: "Анулиране на артикул",
      actionSaleVoid: "Анулиране на продажба",
      actionSaleStorno: "Сторно на продажба",
      actionPayment: "Плащане",
      actionConfigChange: "Промяна в конфигурацията",
      actionSessionCreated: "Сесия създадена",
      actionSessionRefreshed: "Сесия обновена",
      actionSessionLocked: "Сесия заключена",
      actionSessionUnlocked: "Сесия отключена",
      actionTableMove: "Преместване на маса",
      actionTableMergeOccupied: "Сливане на заети маси",
      actionStaffClockIn: "Начало на смяна",
      actionStaffClockOut: "Край на смяна",
      actionStaffShiftAdjust: "Корекция на смяна",
      detailsSaleOpen: "Маса: {table}, Гости: {guests}",
      detailsItemVoid: "Анулиран артикул {itemId}",
      detailsSaleStorno: "Причина: {reason}",
      detailsPayment: "Метод: {method}, Общо: {total}",
      detailsConfigChange: "{entity} {action} {name}",
      detailsSession: "Сесия: {sessionId}",
    },
    // NAP Exports
    napExports: {
      napExports: "НАП експорти (Н-18 т.18)",
      description: "Изтеглете обобщени продажби, плащания и детайлни артикули във формат CSV за НАП инспекции.",
      accessDenied: "Достъп отказан",
      accessDeniedDesc: "Нямате разрешение да преглеждате НАП експорти.",
      failedToDownload: "Неуспешно изтегляне на експорт",
      from: "От",
      to: "До",
      operatorCodeOptional: "Код на оператор (незадължително)",
      operatorCodePlaceholder: "напр. 0002",
      summarySales: "18.1 Обобщени продажби",
      summarySalesDesc: "Един ред на продажба със суми и времеви маркери.",
      payments: "18.2 Плащания",
      paymentsDesc: "Плащания на продажба с метод, суми и номер на ФУ.",
      lineItems: "18.3 Артикули",
      lineItemsDesc: "Детайлни артикули на продажба (статии, количества, ДДС).",
      stornoSales: "18.4 Сторно продажби",
      stornoSalesDesc: "Сторно продажби по ред (с дата на сторно, час и номер на ФУ).",
      annulledItems: "18.5 Анулирани артикули",
      annulledItemsDesc: "Анулирани артикули на продажба с дата на анулиране, час и оператор.",
      deliveriesBasic: "18.6 Доставки (основни)",
      deliveriesBasicDesc: "Основни записи за доставки от склад (количества; други полета са празни засега).",
      deliveryLines: "18.7 Редове за доставка",
      deliveryLinesDesc: "Детайлни записи за доставка на инвентарен артикул (само количества).",
      stockMovement: "18.8 Движение на стоки",
      stockMovementDesc: "Начални, дебитни, кредитни и крайни количества на инвентарен артикул.",
      products: "18.9 Продукти",
      productsDesc: "Кодове на продукти, имена, категории и времеви маркери за живот.",
      venuesWorkstations: "18.9 Заведения и работни станции",
      venuesWorkstationsDesc: "Експортира заведения и ПОС устройства (работни станции) за текущото заведение.",
      usersRoles: "18.9 Потребители и роли",
      usersRolesDesc: "Оператори с техните кодове; използвайте отделни експорти за Роли и Методи на плащане за пълни номенклатури.",
      roles: "18.9 Роли",
      rolesDesc: "Кодове на роли, български имена и JSON за разрешения за оператори.",
      paymentMethods: "18.9 Методи на плащане",
      paymentMethodsDesc: "Статичен списък с кодове на методи на плащане (в брой, карта, друго).",
      preparingExport: "Подготвяне на експорт файл, моля изчакайте...",
    },
    // Clock In
    clockIn: {
      quantbar: "Quantbar",
      clockIn: "Влез в смяна",
      pleaseClockInToStartShift: "Моля, влезте в смяна, за да започнете вашата смяна",
      clockingIn: "Влизане в смяна...",
      failedToClockIn: "Неуспешно влизане в смяна",
      skipForNow: "Пропусни засега",
    },
    // Top Bar
    topBar: {
      searchTables: "Търсене на маси",
      account: "Профил",
      clockOutAndLogOut: "Излез от смяна и излез",
      logOut: "Излез",
    },
    // Reservations
    reservations: {
      title: "Резервации",
      newReservation: "Нова резервация",
      editReservation: "Редактиране на резервация",
      today: "Днес",
      upcoming: "Предстоящи",
      noReservations: "Няма резервации за този ден",
      noUpcoming: "Няма предстоящи резервации",
      createFirst: "Създайте една",
      guestName: "Име на гост",
      guestNamePlaceholder: "Иван Петров",
      guestNameRequired: "Името на госта е задължително",
      phone: "Телефон",
      date: "Дата",
      time: "Час",
      duration: "Продължителност",
      partySize: "Брой гости",
      isParty: "Парти / Събитие",
      selectTables: "Маси",
      noTables: "Няма намерени маси",
      notes: "Бележки",
      notesPlaceholder: "Специални изисквания, алергии...",
      save: "Запази",
      create: "Създай резервация",
      close: "Затвори",
      updateStatus: "Промяна на статус",
      seatGuests: "Настаняване",
      markCompleted: "Завършена",
      noShow: "Не се явиха",
      cancel: "Отмяна на резервация",
      guests: "гости",
      reserve: "Резервирай",
    },
    expenses: {
      title: "Бизнес разходи",
      addExpense: "Добави разход",
      editExpense: "Редактирай разход",
      description: "Описание",
      category: "Категория",
      netAmount: "Нето сума",
      vatAmount: "ДДС (20%)",
      totalAmount: "Общо",
      date: "Дата",
      recurrence: "Повторение",
      oneTime: "Еднократно",
      daily: "Дневно",
      weekly: "Седмично",
      monthly: "Месечно",
      yearly: "Годишно",
      notes: "Бележки",
      noExpenses: "Няма записани разходи",
      suggestionsHint: "Това са предложения — натиснете за да добавите каквото се отнася за вашия обект",
      loading: "Зареждане на разходи...",
      failedToLoad: "Неуспешно зареждане",
      created: "Разходът е създаден",
      updated: "Разходът е актуализиран",
      deleted: "Разходът е изтрит",
      totalExpenses: "Общо разходи",
      recurring: "Повтарящ се",
      confirmDelete: "Изтриване на този разход?",
      ghostRent: "Наем",
      ghostUtilities: "Комунални услуги",
      ghostSupplies: "Консумативи",
      ghostInsurance: "Застраховки",
      ghostMaintenance: "Поддръжка и ремонти",
      ghostSalaries: "Заплати",
      ghostMarketing: "Маркетинг и реклама",
      ghostLicenses: "Лицензи и разрешителни",
    },
    // Table Timer Add-on
    tableTimer: {
      title: "Таймер за маса",
      startTimer: "Стартирай таймер",
      stopTimer: "Спри таймер",
      running: "Работи",
      elapsed: "Изминало време",
      runningCost: "Текуща цена",
      selectPricingTier: "Моля, изберете ценова тарифа",
      timerStarted: "Таймерът е стартиран",
      timerCancelled: "Таймерът е отменен",
      sessionEnded: "Сесията приключи",
      totalCharge: "Обща сума",
      addedToOrder: "Таксата за време е добавена към поръчката",
      noPricingTiers: "Няма конфигурирани ценови тарифи. Настройте ги в Настройки.",
      liveSessions: "Активни сесии",
      settings: "Настройки",
      noActiveSessions: "Няма активни таймер сесии в момента.",
      pricingTiers: "Ценови тарифи",
      pricingTiersDesc: "Конфигурирайте цените за дейности с време (билярд, пул, тенис и др.)",
      existingTiers: "Съществуващи тарифи",
      createTier: "Създай ценова тарифа",
      editTier: "Редактирай ценова тарифа",
      tierName: "Име на дейност",
      tierNamePlaceholder: "напр. Билярд, Тенис, Пул",
      tierNameRequired: "Името на дейността е задължително",
      pricingBreakpoints: "Ценови точки",
      addRow: "Добави точка",
      preview: "Преглед",
      atLeastOneTier: "Необходима е поне една ценова точка",
      minutesMustBePositive: "Минутите трябва да са положително число",
      priceMustBePositive: "Цената не може да е отрицателна",
      duplicateMinutes: "Не се допускат дублирани стойности за минути",
      tierCreated: "Ценовата тарифа е създадена",
      tierUpdated: "Ценовата тарифа е обновена",
      tierDeleted: "Ценовата тарифа е изтрита",
      pageTitle: "Таймер за маси",
      pageDesc: "Управлявайте ценови тарифи и задайте таймери на маси",
      tableAssignments: "Задаване на маси",
      tableAssignmentsDesc: "Изберете кои маси имат таймер и коя ценова тарифа използват",
      noTables: "Няма намерени маси. Първо създайте маси в ПОС.",
      timerAssigned: "Таймер зададен на {tableName}",
      timerRemoved: "Таймерът е премахнат от {tableName}",
      addonNotEnabled: "Добавката Таймер за маси не е активирана",
      addonNotEnabledDesc: "Активирайте добавката Таймер за маси от абонамента си, за да използвате тази функция.",
    },
    // Suppliers
    suppliers: {
      title: "Доставчици",
      addSupplier: "Добави доставчик",
      editSupplier: "Редактирай доставчик",
      name: "Име",
      contactName: "Лице за контакт",
      phone: "Телефон",
      email: "Имейл",
      notes: "Бележки",
      actions: "Действия",
      edit: "Редактирай",
      deactivate: "Деактивирай",
      reactivate: "Активирай",
      searchPlaceholder: "Търсене на доставчици...",
      showInactive: "Покажи неактивни",
      inactive: "Неактивен",
      noSuppliersYet: "Все още няма доставчици",
      noSuppliersHint: "Добавете първия си доставчик, за да започнете да записвате доставки.",
      noSuppliersMatch: "Няма доставчици, отговарящи на търсенето",
      supplierCreated: "Доставчикът е създаден",
      supplierUpdated: "Доставчикът е обновен",
      supplierDeactivated: "Доставчикът е деактивиран",
      supplierReactivated: "Доставчикът е активиран",
      nameRequired: "Името на доставчика е задължително",
      failedToLoad: "Неуспешно зареждане на доставчици",
      failedToSave: "Неуспешно запазване на доставчик",
      failedToDeactivate: "Неуспешно деактивиране на доставчик",
      failedToReactivate: "Неуспешно активиране на доставчик",
      create: "Създай",
      update: "Обнови",
      cancel: "Отказ",
      contactPerson: "Лице за контакт",
      namePlaceholder: "напр. Метро Кеш енд Кери",
      deliveryScheduleHint: "График за доставки, условия на плащане и др.",
    },
    // Deliveries
    deliveries: {
      title: "Доставки",
      newDelivery: "Нова доставка",
      logDelivery: "Запиши доставка",
      back: "Назад",
      invoiceDetails: "Данни за фактурата",
      supplier: "Доставчик",
      selectSupplier: "Изберете доставчик...",
      invoiceNumber: "Номер на фактура",
      invoiceDate: "Дата на фактура",
      deliveryDate: "Дата на доставка",
      notes: "Бележки",
      optionalNotes: "Допълнителни бележки за доставката",
      lineItems: "Позиции",
      addLine: "Добави позиция",
      item: "Артикул",
      selectItem: "Въведете за търсене или създаване...",
      quantity: "Количество",
      costPerUnit: "Цена/Ед.",
      expiry: "Срок",
      total: "Общо",
      remove: "Премахни",
      grandTotal: "Обща сума",
      cancel: "Отказ",
      saving: "Запазване...",
      deliveryCreated: "Доставката е записана успешно",
      failedToCreate: "Неуспешно създаване на доставка",
      failedToLoad: "Неуспешно зареждане на доставки",
      failedToLoadData: "Неуспешно зареждане на данни",
      selectSupplierError: "Моля, изберете доставчик",
      addLineError: "Добавете поне една валидна позиция",
      // List page
      allSuppliers: "Всички доставчици",
      allStatuses: "Всички статуси",
      from: "От",
      to: "До",
      status: "Статус",
      date: "Дата",
      noDeliveries: "Няма намерени доставки",
      noDeliveriesHint: "Запишете първата си доставка, за да проследявате разходите и наличностите.",
      loading: "Зареждане на доставки...",
      // Statuses
      statusPending: "Чакаща",
      statusVerified: "Потвърдена",
      statusPartiallyVerified: "Частично потвърдена",
      statusDisputed: "Оспорена",
      // Detail page
      deliveryDetail: "Детайли за доставка",
      expected: "Очаквано",
      received: "Получено",
      verified: "Потвърдено",
      unverified: "Непотвърдено",
      verifyAll: "Потвърди всички",
      deleteDelivery: "Изтрий доставка",
      deleteDeliveryConfirm: "Сигурни ли сте, че искате да изтриете тази доставка? Това ще отмени всички промени в наличностите.",
      verificationProgress: "Прогрес на потвърждение",
      verifyLine: "Потвърди позиция",
      quantityReceived: "Получено количество",
      verifyNotes: "Бележки (по избор)",
      verify: "Потвърди",
      deliveryVerified: "Доставката е потвърдена",
      deliveryDeleted: "Доставката е изтрита",
      lineVerified: "Позицията е потвърдена",
      failedToVerify: "Неуспешно потвърждение",
      failedToDelete: "Неуспешно изтриване на доставка",
      // Detail extras
      loadingDelivery: "Зареждане на доставка...",
      deliveryNotFound: "Доставката не е намерена",
      deliveryDetails: "Детайли за доставка",
      verifiedBanner: "Всички артикули са потвърдени. Доставката е завършена.",
      invoice: "Фактура",
      totalCost: "Обща стойност",
      verifiedProgress: "Потвърдени: {verified} / {total} позиции",
      lineTotal: "Сума по позиция",
      action: "Действие",
      pendingStatus: "Чакаща",
      verifiedStatus: "Потвърдена",
      verifyModalDesc: "Въведете действително полученото количество. Ако се различава от очакваното, складовата партида ще бъде коригирана.",
      verifyNotesPlaceholder: "напр. 2 бутилки повредени",
      enterValidQty: "Въведете валидно получено количество",
      allLinesVerified: "Всички позиции са потвърдени",
      deleteDeliveryTitle: "Изтрий доставка",
      deleteDeliveryMsg: "Изтрий тази доставка? Това ще отмени всички записи в складовите партиди.",
      // Form extras
      newInventoryItem: "Нов артикул в склада",
      nameRequired: "Име *",
      unitRequired: "Мерна единица *",
      creating: "Създаване...",
      create: "Създай",
      failedToCreateItem: "Неуспешно създаване на артикул",
      failedToLoadSuppliers: "Неуспешно зареждане на доставчици",
      failedToLoadInventory: "Неуспешно зареждане на склад",
      createNewItem: "Създай \"{name}\" като нов артикул",
      // Bottle mode
      bottles: "Бутилки",
      bottlesPlaceholder: "Бр.",
      bottleSizeMl: "Размер на бутилка (ml)",
      bottleSizePlaceholder: "напр. 700",
      costPerBottle: "Цена/Бутилка",
      perMl: "ml",
      bottleModeHint: "Артикулите проследявани в ml автоматично ще преминат към въвеждане по бутилки.",
    },
    // Stock Lots
    stockLots: {
      title: "Складови партиди",
      weightedAvgCost: "Средно претеглена цена",
      totalStockValue: "Обща стойност на склада",
      activeLots: "Активни партиди",
      lastDeliveryCost: "Последна цена на доставка",
      consumptionMethod: "Метод на консумация",
      lot: "Партида",
      exhausted: "Изчерпана",
      perUnit: "/ед.",
      received: "Получена",
      expires: "Изтича",
      expired: "ИЗТЕКЛА",
      noLots: "Все още няма складови партиди.",
      noLotsHint: "Запишете доставка, за да създадете първата партида.",
      loading: "Зареждане на партиди...",
      viewLots: "Партиди",
    },
    // Inventory Settings
    inventorySettings: {
      title: "Настройки за склад",
      description: "Конфигурирайте как се консумират наличностите и как се изчисляват разходите.",
      consumptionMethod: "Метод на консумация",
      consumptionMethodDesc: "Определя реда, по който складовите партиди се консумират при продажба на артикули.",
      fifo: "FIFO (Пръв влязъл, пръв излязъл)",
      fefo: "FEFO (Пръв изтичащ, пръв излязъл)",
      manual: "Ръчен",
      costCalculation: "Изчисляване на разходи",
      costCalculationDesc: "Как се определя себестойността на продукта за изчисляване на маржа.",
      weightedAverage: "Средно претеглена",
      lastDelivery: "Цена от последна доставка",
      lotSpecific: "По партида",
      saved: "Настройките за склад са запазени",
      failedToSave: "Неуспешно запазване на настройките за склад",
      failedToLoad: "Неуспешно зареждане на настройките за склад",
    },
    // New Inventory Item (inline creation)
    newInventoryItem: {
      title: "Нов артикул в склада",
      name: "Име",
      unit: "Мерна единица",
      category: "Категория",
      categoryPlaceholder: "напр. Спиртни напитки",
      cancel: "Отказ",
      create: "Създай",
      creating: "Създаване...",
      failedToCreate: "Неуспешно създаване на артикул",
    },
    // Margin
    margin: {
      margin: "Марж",
      marginPercent: "Марж %",
      costPrice: "Себестойност",
      sellPrice: "Продажна цена",
      noMarginData: "Няма налични данни за маржа",
    },
    // Account / Portal
    account: {
      account: "Акаунт",
      accountDesc: "Преглед на организацията и статус на плана.",
      organization: "Организация",
      ownerEmail: "Имейл на собственика",
      currentPlan: "Текущ план",
      billingCycle: "Период на фактуриране",
      periodEnds: "Периодът изтича",
      venues: "Заведения",
      manageSubscription: "Управление на абонамента →",
      browseAddons: "Разгледай добавките →",
      viewVenues: "Виж заведенията →",
      ownerOnly: "Детайлите за акаунта са видими само за собственика на организацията.",
      // Subscription
      subscription: "Абонамент",
      subscriptionDesc: "Управлявайте плана и фактурирането.",
      plan: "План",
      maxVenues: "Макс. заведения",
      cancelSubscription: "Отказ от абонамент",
      cancelNotice: "Планът остава активен до края на текущия период. Можете да го активирате отново по всяко време.",
      keepSubscription: "Запази абонамента",
      confirmCancellation: "Потвърди отказа",
      availablePlans: "Налични планове",
      current: "Текущ",
      switchTo: "Смени на {plan}",
      perMonth: "/мес",
      // Add-ons
      addons: "Добавки",
      addonsDesc: "Разширете POS системата с мощни екстри.",
      active: "Активни",
      marketplace: "Магазин",
      noAddonsAvailable: "Няма налични добавки за вашия план.",
      activate: "Активирай",
      deactivate: "Деактивирай",
      // Venues
      venuesTitle: "Заведения",
      venuesDesc: "Вашите регистрирани локации.",
      venueOwnerOnly: "Управлението на заведения е достъпно само за собственика на организацията.",
      added: "Добавено",
      activeStatus: "Активно",
      inactiveStatus: "Неактивно",
      noVenuesFound: "Няма намерени заведения. Заведенията се управляват от POS приложението.",
      venuesFromPos: "Заведенията се създават и конфигурират от POS приложението (десктоп/таблет).",
    },
    // Auth Launch
    launch: {
      missingToken: "Липсва токен за стартиране.",
      failedAuth: "Неуспешна автентикация. Моля, влезте ръчно.",
      signInManually: "Влезте ръчно →",
      openingDashboard: "Отваряне на таблото…",
    },
    // Homepage
    home: {
      welcome: "Добре дошли, {name}!",
      role: "Роля",
      logout: "Изход",
    },
  },
};

Object.assign(translations.bg.staff, {
  teamRosterDesc:
    '\u0412\u0438\u0436\u0442\u0435 \u043a\u043e\u0439 \u0435 \u043d\u0430 \u0441\u043c\u044f\u043d\u0430 \u0438 \u0443\u043f\u0440\u0430\u0432\u043b\u044f\u0432\u0430\u0439\u0442\u0435 \u0435\u043a\u0438\u043f\u0430 \u043d\u0430 \u0437\u0430\u0432\u0435\u0434\u0435\u043d\u0438\u0435\u0442\u043e \u043e\u0442 \u043c\u043e\u0431\u0438\u043b\u043d\u043e\u0442\u043e \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435.',
  failedToLoad:
    '\u041d\u0435\u0443\u0441\u043f\u0435\u0448\u043d\u043e \u0437\u0430\u0440\u0435\u0436\u0434\u0430\u043d\u0435 \u043d\u0430 \u043f\u0435\u0440\u0441\u043e\u043d\u0430\u043b\u043d\u0438\u044f \u0441\u044a\u0441\u0442\u0430\u0432',
  searchStaff: '\u0422\u044a\u0440\u0441\u0435\u043d\u0435 \u043d\u0430 \u043f\u0435\u0440\u0441\u043e\u043d\u0430\u043b',
  showing: '\u041f\u043e\u043a\u0430\u0437\u0430\u043d\u0438',
  totalRoster: '\u041e\u0431\u0449 \u0441\u044a\u0441\u0442\u0430\u0432',
  manageStaff:
    '\u0423\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0435 \u043d\u0430 \u043f\u0435\u0440\u0441\u043e\u043d\u0430\u043b\u0430',
  exitManageMode:
    '\u0418\u0437\u0445\u043e\u0434 \u043e\u0442 \u0440\u0435\u0436\u0438\u043c\u0430 \u0437\u0430 \u0443\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0435',
  noStaffFoundDesc:
    '\u041e\u043f\u0438\u0442\u0430\u0439\u0442\u0435 \u0441 \u0434\u0440\u0443\u0433\u043e \u0442\u044a\u0440\u0441\u0435\u043d\u0435 \u0438\u043b\u0438 \u0444\u0438\u043b\u0442\u044a\u0440 \u043f\u043e \u043e\u0442\u0434\u0435\u043b.',
  hireNewStaffDesc:
    '\u0421\u044a\u0437\u0434\u0430\u0439\u0442\u0435 \u0430\u043a\u0430\u0443\u043d\u0442 \u0437\u0430 \u0441\u043b\u0443\u0436\u0438\u0442\u0435\u043b \u0438 \u0433\u0435\u043d\u0435\u0440\u0438\u0440\u0430\u0439\u0442\u0435 \u043e\u043f\u0435\u0440\u0430\u0442\u043e\u0440\u0441\u043a\u0438 \u0434\u0430\u043d\u043d\u0438.',
  jobTitlePlaceholder:
    '\u0421\u0435\u0440\u0432\u0438\u0442\u044c\u043e\u0440, \u0431\u0430\u0440\u043c\u0430\u043d, \u0433\u043e\u0442\u0432\u0430\u0447...',
  notClockedIn: '\u041d\u0435 \u0435 \u0432\u043b\u044f\u0437\u044a\u043b \u0432 \u0441\u043c\u044f\u043d\u0430',
  saveCredentialsBeforeClosing:
    '\u0417\u0430\u043f\u0430\u0437\u0435\u0442\u0435 \u0442\u0435\u0437\u0438 \u0434\u0430\u043d\u043d\u0438 \u043f\u0440\u0435\u0434\u0438 \u0437\u0430\u0442\u0432\u0430\u0440\u044f\u043d\u0435. \u0422\u0435 \u0441\u0435 \u043f\u043e\u043a\u0430\u0437\u0432\u0430\u0442 \u0441\u0430\u043c\u043e \u0432\u0435\u0434\u043d\u044a\u0436 \u0437\u0430',
  fireStaffModalDesc:
    '\u041f\u0440\u0435\u043c\u0430\u0445\u043d\u0435\u0442\u0435 {name} \u043e\u0442 \u0430\u043a\u0442\u0438\u0432\u043d\u0438\u044f \u043f\u0435\u0440\u0441\u043e\u043d\u0430\u043b \u043d\u0430 \u0437\u0430\u0432\u0435\u0434\u0435\u043d\u0438\u0435\u0442\u043e. \u041e\u043f\u0435\u0440\u0430\u0442\u043e\u0440\u0441\u043a\u0438\u044f\u0442 \u043a\u043e\u0434 \u043e\u0441\u0442\u0430\u0432\u0430 \u0432 \u043e\u0434\u0438\u0442\u043d\u0430\u0442\u0430 \u0438\u0441\u0442\u043e\u0440\u0438\u044f.',
  editStaffDesc:
    '\u0410\u043a\u0442\u0443\u0430\u043b\u0438\u0437\u0438\u0440\u0430\u0439\u0442\u0435 \u0434\u0430\u043d\u043d\u0438\u0442\u0435 \u0438 \u043f\u0440\u0430\u0432\u0430\u0442\u0430 \u043d\u0430 \u0441\u043b\u0443\u0436\u0438\u0442\u0435\u043b\u044f.',
  hiring: '\u041d\u0430\u0435\u043c\u0430\u043d\u0435...',
  firing: '\u041e\u0441\u0432\u043e\u0431\u043e\u0436\u0434\u0430\u0432\u0430\u043d\u0435...',
});

Object.assign(translations.bg.settings, {
  languageEnglish: 'English',
  languageBulgarian: '\u0411\u044a\u043b\u0433\u0430\u0440\u0441\u043a\u0438',
});

